import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { FormControl, Toast, ToastContainer } from "react-bootstrap";
import authHeader from "../Services/auth-header";
import Modal from "react-bootstrap/Modal";
import Select from "react-dropdown-select";
import CustomDropdownWithSearch from "../Components/CustomDropdownWithSearch";
import CustomDropdown from "../Components/CustomDropdown";
import CustomControl from "../Components/CustomControl";
import CustomDropdownMulti from "../Components/CustomDropdownMulti";
import CustomDropdownMultiWithSearch from "../Components/CustomDropdownMultiWithSearch";
import CustomControlMulti from "../Components/CustomControlMulti";
import LoadingOverlay from "react-loading-overlay";
import { refreshToken } from "../Services/auth.service";
import { GridContextProvider, GridDropZone, GridItem, swap } from "react-grid-drag";
import ReactPaginate from "react-paginate";
import ReactQuill from "react-quill";

import { baseURLGetPages, baseURLGetModels, baseURLProductGroups, baseURLEditPage, baseURLAddPage, baseURLDeletePage, baseURLFabrics, baseURLModel, baseURLFilterColor, baseURLFilterPattern, baseURLFilterType, baseURLFilterPrice, baseURLFilterOpacity, baseURLFilterSize, baseURLFilterHangingStyle, imgUrl } from "../config/api";
function PageItems() {
  const [pageItems, setPageItems] = useState([]);
  const [childrenPageItems, setChildrenPageItems] = useState([]);
  const [models, setModels] = useState([]);
  const [products, setProducts] = useState([]);
  const [sewingColors, setSewingColors] = useState([]);
  const [sewingPatterns, setSewingPatterns] = useState([]);
  const [sewingTypes, setSewingTypes] = useState([]);
  const [sewingPrices, setSewingPrices] = useState([]);
  const [sewingOpacity, setSewingOpacity] = useState([]);
  const [sewingSize, setSewingSize] = useState([]);
  const [sewingHangingStyle, setSewingHangingStyle] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageItemsList, setPageItemsList] = useState([]);
  const [currentPageItemsList, setCurrentPageItemsList] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(Math.ceil(pageItemsList.length / itemsPerPage));

  const [isLoading, setIsLoading] = useState(false);
  const [fabricIsLoading, setFabricIsLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [show, setShow] = useState(false);
  const [showFabrics, setShowFabrics] = useState(false);
  const [showFabrics2, setShowFabrics2] = useState(false);
  const [parameters, setParameters] = useState(undefined);
  const [refIndex, setRefIndex] = useState(-1);
  const [fabricsDragList, setFabricsDragList] = useState({});
  const [AccColorsDragList, setAccColorsDragList] = useState({});
  const [dragListFabricsList, setDragListFabricsList] = useState([]);
  const [dragListDesignsList, setDragListDesignsList] = useState([]);
  const [dragListAccessoryList, setDragListAccessoryList] = useState([]);
  const [dragListAccessoryColorsList, setDragListAccessoryColorsList] = useState([]);
  const [isDesignDrag, setIsDesignDrag] = useState(0);
  const [newPageItem, setNewPageItem] = useState({
    PageName: "",
    LinkName: "",
    PageTypeId: null,
    ColumnCount: 0,
    Title: "",
    EnTitle: "",
    RelatedPage: "",
    Price: 0,
    DiscountPrice: 0,
    DiscountPercent: 0,
    Description: null,
    DescriptionEn: null,
    ImageFile: null,
    ImageUrl: null,
    OverImage: null,
    OverImageUrl: null,
    MainImageFile: null,
    MainImageUrl: null,
    Link: "",
    QueryString: "",
    HtmlContent: "",
    HtmlEnContent: "",
  });

  const [fabricsList, setFabricsList] = useState([]);
  const [fabricsButtonList, setFabricsButtonList] = useState([]);
  const [fabricDesigns2, setFabricDesigns2] = useState({
    refIndex: null,
    id: null,
    type: null,
    order: -1,
    onlyOne: null,
    fabrics: [],
  });

  const [fabricDesigns, setFabricDesigns] = useState({
    refIndex: null,
    id: null,
    type: null,
    order: -1,
    onlyOne: null,
    fabrics: [],
  });
  const [fabricOrders, setFabricOrders] = useState({
    refIndex: null,
    id: null,
    type: null,
    order: -1,
    fabrics: [],
  });

  const [fabricChanged, setFabricChanged] = useState({
    refIndex: -1,
    fabrics: [],
    save: false,
    clear: false,
  });
  const sortFabric = useRef(null);
  const fabricLoadingTimeoutRef = useRef(null);
  const fabricLoadingPromiseRef = useRef(null);
  const fabricLoadingSafetyTimeoutRef = useRef(null);
  const isDragInProgressRef = useRef(false);
  const lastParametersRef = useRef(null);

  const DesignType = [
    { value: "none", label: "none" },
    { value: "Base", label: "Base" },
    { value: "Decorative", label: "Decorative" },
  ];

  const DesignOne = [{ value: "none", label: "no" }, { value: "one", label: "yes" }];

  function convertToPersian(string_farsi) {
    let tempString = string_farsi.replace("ي", "ی");
    tempString = tempString.replace("ي", "ی");
    tempString = tempString.replace("ي", "ی");
    tempString = tempString.replace("ي", "ی");
    tempString = tempString.replace("ك", "ک");
    return tempString;
  }

  const PageTypeOptions = [{ value: 5501, label: "Product" }, { value: 5502, label: "Curtain" }];
  const ChildViewOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  const relatedPages = [
    { value: "Ready-Made-Drapery", label: "Ready-Made-Drapery" },
    { value: "ready-made-shade", label: "ready-made-shade" },
    { value: "ready-made-fabric", label: "ready-made-fabric" },
    // {value: "Rods", label: "Rods"},
    // {value: "Product", label: 'Product'},
    { value: "ready-made-product", label: "ready-made-product" },
    // {value: "collections", label: 'collections'},
    { value: "Collection", label: "Collection" },
    { value: "collection-shade", label: "collection-shade" },
  ];

  const curtainRelatedPages = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
  ];

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % pageItemsList.length;
    setItemOffset(newOffset);
  };

  function dragOnChange(sourceId, sourceIndex, targetIndex, targetId, tempFabrics, key) {
    // Prevent unnecessary updates if source and target are the same
    if (sourceIndex === targetIndex) {
      return;
    }
    // Prevent multiple simultaneous drag operations
    if (isDragInProgressRef.current) {
      return;
    }
    isDragInProgressRef.current = true;
    let temp = JSON.parse(JSON.stringify(tempFabrics));
    let params = JSON.parse(JSON.stringify(parameters));

    // Check if temp[key] exists and is an array
    if (!temp[key] || !Array.isArray(temp[key])) {
      console.error("Invalid tempFabrics key or not an array:", key, temp[key]);
      isDragInProgressRef.current = false;
      return;
    }

    setFabricIsLoading(true);
    const nextState = swap(temp[key], sourceIndex, targetIndex);

    for (let j = 0; j < nextState.length; j++) {
      // Skip if item is null or undefined
      if (!nextState[j] || !nextState[j]["FabricId"]) {
        continue;
      }

      if (params["Fabrics"]) {
        if (params["Fabrics"][nextState[j]["FabricId"]]) {
          params["Fabrics"][nextState[j]["FabricId"]]["order"] = j;
        } else {
          params["Fabrics"][nextState[j]["FabricId"]] = {};
          params["Fabrics"][nextState[j]["FabricId"]]["order"] = j;
        }
      } else {
        params["Fabrics"] = {};
        params["Fabrics"][nextState[j]["FabricId"]] = {};
        params["Fabrics"][nextState[j]["FabricId"]]["order"] = j;
      }
    }
    setParameters(params);
    // Reset drag flag after a short delay
    setTimeout(() => {
      isDragInProgressRef.current = false;
    }, 100);
  }

  function dragOnChangeDesigns(sourceId, sourceIndex, targetIndex, targetId, designOrders) {
    // Prevent unnecessary updates if source and target are the same
    if (sourceIndex === targetIndex) {
      return;
    }
    // Prevent multiple simultaneous drag operations
    if (isDragInProgressRef.current) {
      return;
    }
    isDragInProgressRef.current = true;
    let temp = JSON.parse(JSON.stringify(designOrders));
    let params = JSON.parse(JSON.stringify(parameters));
    setFabricIsLoading(true);
    const nextState = swap(temp, sourceIndex, targetIndex);
    for (let j = 0; j < nextState.length; j++) {
      if (params["Designs"]) {
        if (params["Designs"][nextState[j]]) {
          params["Designs"][nextState[j]]["order"] = j;
        } else {
          params["Designs"][nextState[j]] = {};
          params["Designs"][nextState[j]]["order"] = j;
        }
      } else {
        params["Designs"] = {};
        params["Designs"][nextState[j]] = {};
        params["Designs"][nextState[j]]["order"] = j;
      }
    }
    setParameters(params);
    // Reset drag flag after a short delay
    setTimeout(() => {
      isDragInProgressRef.current = false;
    }, 100);
  }

  function dragOnChange2(sourceId, sourceIndex, targetIndex, targetId, tempFabrics, key) {
    // Prevent unnecessary updates if source and target are the same
    if (sourceIndex === targetIndex) {
      return;
    }
    // Prevent multiple simultaneous drag operations
    if (isDragInProgressRef.current) {
      return;
    }
    isDragInProgressRef.current = true;
    let temp = JSON.parse(JSON.stringify(tempFabrics));
    let params = JSON.parse(JSON.stringify(parameters));

    // Check if temp[key] exists and is an array
    if (!temp[key] || !Array.isArray(temp[key])) {
      console.error("Invalid tempFabrics key or not an array:", key, temp[key]);
      isDragInProgressRef.current = false;
      return;
    }

    setFabricIsLoading(true);
    const nextState = swap(temp[key], sourceIndex, targetIndex);

    for (let j = 0; j < nextState.length; j++) {
      // Skip if item is null or undefined
      if (!nextState[j] || !nextState[j]["DetailId"]) {
        continue;
      }

      if (params["AccColors"]) {
        if (params["AccColors"][nextState[j]["DetailId"]]) {
          params["AccColors"][nextState[j]["DetailId"]]["order"] = j;
        } else {
          params["AccColors"][nextState[j]["DetailId"]] = {};
          params["AccColors"][nextState[j]["DetailId"]]["order"] = j;
        }
      } else {
        params["AccColors"] = {};
        params["AccColors"][nextState[j]["DetailId"]] = {};
        params["AccColors"][nextState[j]["DetailId"]]["order"] = j;
      }
    }
    setParameters(params);
    // Reset drag flag after a short delay
    setTimeout(() => {
      isDragInProgressRef.current = false;
    }, 100);
  }

  function dragOnChangeDesigns2(sourceId, sourceIndex, targetIndex, targetId, designOrders) {
    // Prevent unnecessary updates if source and target are the same
    if (sourceIndex === targetIndex) {
      return;
    }
    // Prevent multiple simultaneous drag operations
    if (isDragInProgressRef.current) {
      return;
    }
    isDragInProgressRef.current = true;
    let temp = JSON.parse(JSON.stringify(designOrders));
    let params = JSON.parse(JSON.stringify(parameters));
    setFabricIsLoading(true);

    console.log(temp);
    const nextState = swap(temp, sourceIndex, targetIndex);
    //
    // console.log(nextState);
    for (let j = 0; j < nextState.length; j++) {
      // Skip if item is null or undefined
      if (!nextState[j]) {
        continue;
      }

      if (params["AccDesigns"]) {
        if (params["AccDesigns"][nextState[j]]) {
          params["AccDesigns"][nextState[j]]["order"] = j;
        } else {
          params["AccDesigns"][nextState[j]] = {};
          params["AccDesigns"][nextState[j]]["order"] = j;
        }
      } else {
        params["AccDesigns"] = {};
        params["AccDesigns"][nextState[j]] = {};
        params["AccDesigns"][nextState[j]]["order"] = j;
      }
    }
    setParameters(params);
    // Reset drag flag after a short delay
    setTimeout(() => {
      isDragInProgressRef.current = false;
    }, 100);
  }

  function getPageItems() {
    axios
      .get(baseURLGetPages, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.data.length) {
          setPageItems(response.data);
          setChildrenPageItems(
            response.data.map(function(obj) {
              return {
                value: obj["WebsitePageId"],
                label: obj["WebsitePageId"] + " | " + obj["PageName"],
              };
            })
          );
        } else {
          console.log("failed");
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              getPageItems();
            } else {
            }
          });
        } else {
          console.log("failed");
        }
      });
  }

  function getSelections() {
    let promiseArr = [];
    promiseArr[0] = new Promise((resolve, reject) => {
      axios
        .get(baseURLGetModels)
        .then((response) => {
          let arr = response.data || [];
          let tempArr = [];
          let promiseArr2 = [];
          arr.forEach((el, i) => {
            promiseArr2[i] = new Promise((resolve, reject) => {
              if (el["SewingModelId"] && el["ModelENName"]) {
                tempArr.push({
                  value: el["SewingModelId"],
                  label: el["ModelENName"] + "(ID=" + el["SewingModelId"] + ")",
                });
              }
              resolve();
            });
          });

          Promise.all(promiseArr2).then(() => {
            setModels(tempArr);
            resolve();
          });
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                getSelections();
              } else {
              }
            });
          } else {
            console.log("failed");
          }
          reject();
        });
    });
    promiseArr[1] = new Promise((resolve, reject) => {
      axios
        .get(baseURLFilterColor)
        .then((response) => {
          let arr = response.data || [];
          let tempArr = [];
          let promiseArr2 = [];
          arr.forEach((el, i) => {
            promiseArr2[i] = new Promise((resolve, reject) => {
              if (el["ColorId"] && el["ColorENName"]) {
                tempArr.push({ value: el["ColorId"]?.toString(), label: el["ColorENName"] });
              }
              resolve();
            });
          });

          Promise.all(promiseArr2).then(() => {
            const updatedTempArr = tempArr.map((item) => {
              if (item.label) {
                item.label = item.label.replace(/ /g, "_");
              }
              return item;
            });
            setSewingColors(updatedTempArr);
            resolve();
          });
        })
        .catch((err) => {
          console.log(err);
          reject();
        });
    });
    promiseArr[2] = new Promise((resolve, reject) => {
      axios
        .get(baseURLFilterPattern)
        .then((response) => {
          let arr = response.data || [];
          let tempArr = [];
          let promiseArr2 = [];
          arr.forEach((el, i) => {
            promiseArr2[i] = new Promise((resolve, reject) => {
              if (el["BaseTypeDetailId"] && el["ENName"]) {
                tempArr.push({ value: el["BaseTypeDetailId"]?.toString(), label: el["ENName"] });
              }
              resolve();
            });
          });

          Promise.all(promiseArr2).then(() => {
            const updatedTempArr = tempArr.map((item) => {
              if (item.label) {
                item.label = item.label.replace(/ /g, "_");
              }
              return item;
            });
            setSewingPatterns(updatedTempArr);
            resolve();
          });
        })
        .catch((err) => {
          console.log(err);
          reject();
        });
    });
    promiseArr[3] = new Promise((resolve, reject) => {
      axios
        .get(baseURLFilterType)
        .then((response) => {
          let arr = response.data || [];
          let tempArr = [];
          let promiseArr2 = [];
          arr.forEach((el, i) => {
            promiseArr2[i] = new Promise((resolve, reject) => {
              if (el["BaseTypeDetailId"] && el["ENName"]) {
                tempArr.push({ value: el["BaseTypeDetailId"]?.toString(), label: el["ENName"] });
              }
              resolve();
            });
          });

          Promise.all(promiseArr2).then(() => {
            const updatedTempArr = tempArr.map((item) => {
              if (item.label) {
                item.label = item.label.replace(/ /g, "_");
              }
              return item;
            });
            setSewingTypes(updatedTempArr);
            resolve();
          });
        })
        .catch((err) => {
          console.log(err);
          reject();
        });
    });
    promiseArr[4] = new Promise((resolve, reject) => {
      axios
        .get(baseURLFilterPrice)
        .then((response) => {
          let arr = response.data || [];
          let tempArr = [];
          let promiseArr2 = [];
          arr.forEach((el, i) => {
            promiseArr2[i] = new Promise((resolve, reject) => {
              if (el["ProductPriceLevelId"] && el["LevelEnTitle"]) {
                tempArr.push({
                  value: el["ProductPriceLevelId"]?.toString(),
                  label: el["LevelEnTitle"],
                });
              }
              resolve();
            });
          });

          Promise.all(promiseArr2).then(() => {
            const updatedTempArr = tempArr.map((item) => {
              if (item.label) {
                item.label = item.label.replace(/ /g, "_");
              }
              return item;
            });
            setSewingPrices(updatedTempArr);
            resolve();
          });
        })
        .catch((err) => {
          console.log(err);
          reject();
        });
    });
    promiseArr[5] = new Promise((resolve, reject) => {
      axios
        .get(baseURLFilterOpacity)
        .then((response) => {
          let arr = response.data || [];
          let tempArr = [];
          let promiseArr2 = [];
          arr.forEach((el, i) => {
            promiseArr2[i] = new Promise((resolve, reject) => {
              if (el["BaseTypeDetailId"] && el["ENName"]) {
                tempArr.push({ value: el["BaseTypeDetailId"]?.toString(), label: el["ENName"] });
              }
              resolve();
            });
          });

          Promise.all(promiseArr2).then(() => {
            const updatedTempArr = tempArr.map((item) => {
              if (item.label) {
                item.label = item.label.replace(/ /g, "_");
              }
              return item;
            });
            setSewingOpacity(updatedTempArr);
            resolve();
          });
        })
        .catch((err) => {
          console.log(err);
          reject();
        });
    });
    promiseArr[6] = new Promise((resolve, reject) => {
      axios
        .get(baseURLFilterSize)
        .then((response) => {
          let arr = response.data || [];
          let tempArr = [];
          let promiseArr2 = [];
          arr.forEach((el, i) => {
            promiseArr2[i] = new Promise((resolve, reject) => {
              if (el["BaseTypeDetailId"] && el["ENName"]) {
                tempArr.push({ value: el["BaseTypeDetailId"]?.toString(), label: el["ENName"] });
              }
              resolve();
            });
          });

          Promise.all(promiseArr2).then(() => {
            const updatedTempArr = tempArr.map((item) => {
              if (item.label) {
                item.label = item.label.replace(/ /g, "_");
              }
              return item;
            });
            setSewingSize(updatedTempArr);
            resolve();
          });
        })
        .catch((err) => {
          console.log(err);
          reject();
        });
    });
    promiseArr[7] = new Promise((resolve, reject) => {
      axios
        .get(baseURLFilterHangingStyle)
        .then((response) => {
          let arr = response.data || [];
          let tempArr = [];
          let promiseArr2 = [];
          arr.forEach((el, i) => {
            promiseArr2[i] = new Promise((resolve, reject) => {
              if (el["SewingModelId"] && el["ModelENName"]) {
                tempArr.push({ value: el["SewingModelId"]?.toString(), label: el["ModelENName"] });
              }
              resolve();
            });
          });

          Promise.all(promiseArr2).then(() => {
            const updatedTempArr = tempArr.map((item) => {
              if (item.label) {
                item.label = item.label.replace(/ /g, "_");
              }
              return item;
            });
            setSewingHangingStyle(updatedTempArr);
            resolve();
          });
        })
        .catch((err) => {
          console.log(err);
          reject();
        });
    });
    promiseArr[8] = new Promise((resolve, reject) => {
      axios
        .get(baseURLProductGroups)
        .then((response) => {
          let arr = response.data || [];
          let tempArr = [];
          let promiseArr2 = [];
          arr.forEach((obj, i) => {
            promiseArr2[i] = new Promise((resolve, reject) => {
              let tempObj = {};
              tempObj["value"] = obj["ProductGroupId"]?.toString();
              tempObj["label"] = obj["ProductGroupENName"] + "(ID=" + obj["ProductGroupId"] + ")";
              tempArr.push(tempObj);
              resolve();
            });
          });

          Promise.all(promiseArr2).then(() => {
            const updatedTempArr = tempArr.map((item) => {
              if (item.label) {
                item.label = item.label.replace(/ /g, "_");
              }
              return item;
            });
            setProducts(updatedTempArr);
            resolve();
          });
        })
        .catch((err) => {
          console.log(err);
          reject();
        });
    });
    Promise.all(promiseArr).then(() => {
      getPageItems();
    });
  }

  function renderPageItems() {
    const pageItemsLists = [];
    let promiseArr = [];
    for (let i = 0; i < pageItems.length; i++) {
      promiseArr[i] = new Promise((resolve, reject) => {
        let WebsitePageId = pageItems[i].WebsitePageId;
        let PageName = pageItems[i].PageName || "";
        let LinkName = pageItems[i].LinkName || "";
        let ColumnCount = pageItems[i].ColumnCount;
        let PageTypeId = pageItems[i].PageTypeId;
        let selectedPageType = PageTypeOptions.find((opt) => opt.value === PageTypeId)
          ? [
              {
                value: PageTypeId,
                label: PageTypeOptions.find((opt) => opt.value === PageTypeId).label,
              },
            ]
          : [];

        let ShowWithChild = pageItems[i].ShowWithChild;
        if (ShowWithChild === "true") ShowWithChild = true;
        if (ShowWithChild === "false") ShowWithChild = false;
        let selectedChildView =
          ShowWithChild === true || ShowWithChild === false
            ? [
                {
                  value: ShowWithChild,
                  label: ChildViewOptions.find((opt) => opt.value === ShowWithChild).label,
                },
              ]
            : [];

        let Title = pageItems[i].Title || "";
        let EnTitle = pageItems[i].EnTitle || "";
        let Description = pageItems[i].Description;
        let DescriptionEn = pageItems[i].DescriptionEn;
        let HtmlContent = pageItems[i].HtmlContent ? pageItems[i].HtmlContent : "";
        let HtmlEnContent = pageItems[i].HtmlEnContent ? pageItems[i].HtmlEnContent : "";
        let Price = pageItems[i].Price;
        let DiscountPrice = pageItems[i].DiscountPrice;
        let DiscountPercent = pageItems[i].DiscountPercent;
        let ImageUrl = pageItems[i].ImageUrl;
        let MainImageUrl = pageItems[i].MainImageUrl;
        let RelatedPage = pageItems[i].RelatedPage;
        let selectedChildren =
          pageItems[i].ChildPages?.map(function(object, index) {
            return {
              value: object["WebsitePageId"],
              label: object["WebsitePageId"] + " | " + object["PageName"],
            };
          }) || [];
        let selectedRelatedPage = relatedPages.find((opt) => opt.value === RelatedPage)
          ? [
              {
                value: RelatedPage,
                label: relatedPages.find((opt) => opt.value === RelatedPage).label,
              },
            ]
          : [];

        let UrlLink = pageItems[i].Link ? pageItems[i].Link : "";
        let UrlLinkArr = UrlLink.split("/");
        let Link = UrlLinkArr[0] ? UrlLinkArr[0] : "";
        console.log(`Link`, Link);

        let selectedModel = models.find((opt) => opt.value === Link)
          ? [{ value: Link, label: models.find((opt) => opt.value === Link)?.label }]
          : [];
        let selectedProduct = products.find((opt) => opt.value === Link)
          ? [{ value: Link, label: products.find((opt) => opt.value === Link).label }]
          : [];
        // let PageType = UrlLinkArr[1] ? UrlLinkArr[1] : "";

        let ModelDesigns = pageItems[i].ModelDesigns ? pageItems[i].ModelDesigns : [];
        let Fabrics = pageItems[i].Fabrics ? pageItems[i].Fabrics : {};
        let AccDesigns = pageItems[i].AccDesigns ? pageItems[i].AccDesigns : {};
        let AccColors = pageItems[i].AccColors ? pageItems[i].AccColors : {};

        let Parameters = pageItems[i].Parameters ? pageItems[i].Parameters : "{}";

        let QueryString = pageItems[i].QueryString ? pageItems[i].QueryString : "";
        if (i === 0) {
          // console.log(AccColors);
        }

        let paramColorsArr = QueryString.split("colors=");
        paramColorsArr = paramColorsArr[1] ? paramColorsArr[1].split("&") : [];
        let paramColors = paramColorsArr[0] ? paramColorsArr[0] : "";
        let paramColorsSelected = paramColors.split(",").filter((n) => n)
          ? [...new Set(paramColors.split(","))]
              .filter((n) => n)
              .map((item) => ({
                value: item,
                label: sewingColors.find((opt) => opt?.label === item)?.label,
              }))
          : [];

        let paramPatternsArr = QueryString.split("patterns=");
        paramPatternsArr = paramPatternsArr[1] ? paramPatternsArr[1].split("&") : [];
        let paramPatterns = paramPatternsArr[0] ? paramPatternsArr[0] : "";
        let paramPatternsSelected = paramPatterns.split(",").filter((n) => n)
          ? [...new Set(paramPatterns.split(","))]
              .filter((n) => n)
              .map((item) => ({
                value: item,
                label: sewingPatterns.find((opt) => opt?.label === item)?.label,
              }))
          : [];

        let paramTypesArr = QueryString.split("type=");
        paramTypesArr = paramTypesArr[1] ? paramTypesArr[1].split("&") : [];
        let paramTypes = paramTypesArr[0] ? paramTypesArr[0] : "";
        let paramTypesSelected = paramTypes.split(",").filter((n) => n)
          ? [...new Set(paramTypes.split(","))]
              .filter((n) => n)
              .map((item) => ({
                value: item,
                label: sewingTypes.find((opt) => opt?.label === item)?.label,
              }))
          : [];

        let paramPricesArr = QueryString.split("prices=");
        paramPricesArr = paramPricesArr[1] ? paramPricesArr[1].split("&") : [];
        let paramPrices = paramPricesArr[0] ? paramPricesArr[0] : "";
        let paramPricesSelected = paramPrices.split(",").filter((n) => n)
          ? [...new Set(paramPrices.split(","))]
              .filter((n) => n)
              .map((item) => ({
                value: item,
                label: sewingPrices.find((opt) => opt?.label === item)?.label,
              }))
          : [];

        let paramOpacityArr = QueryString.split("opacity=");
        paramOpacityArr = paramOpacityArr[1] ? paramOpacityArr[1].split("&") : [];
        let paramOpacity = paramOpacityArr[0] ? paramOpacityArr[0] : "";
        let paramOpacitySelected = paramOpacity.split(",").filter((n) => n)
          ? [...new Set(paramOpacity.split(","))]
              .filter((n) => n)
              .map((item) => ({
                value: item,
                label: sewingOpacity.find((opt) => opt?.label === item)?.label,
              }))
          : [];

        let paramSizeArr = QueryString.split("size=");
        paramSizeArr = paramSizeArr[1] ? paramSizeArr[1].split("&") : [];
        let paramSize = paramSizeArr[0] ? paramSizeArr[0] : "";
        let paramSizeSelected = paramSize.split(",").filter((n) => n)
          ? [...new Set(paramSize.split(","))]
              .filter((n) => n)
              .map((item) => ({
                value: item,
                label: sewingSize.find((opt) => opt.label === item).label,
              }))
          : [];

        let paramHangingStyleArr = QueryString.split("hangingStyle=");
        paramHangingStyleArr = paramHangingStyleArr[1] ? paramHangingStyleArr[1].split("&") : [];
        let paramHangingStyle = paramHangingStyleArr[0] ? paramHangingStyleArr[0] : "";
        let paramHangingStyleSelected = paramHangingStyle.split(",").filter((n) => n)
          ? [...new Set(paramHangingStyle.split(","))]
              .filter((n) => n)
              .map((item) => ({
                value: item,
                label: sewingHangingStyle.find((opt) => opt?.label === item)?.label,
              }))
          : [];

        let paramDesignsArr;
        let paramDesigns;
        let paramDesignsSelected;
        if (ModelDesigns.length) {
          paramDesignsArr = QueryString.split("designs=");
          paramDesignsArr = paramDesignsArr[1] ? paramDesignsArr[1].split("&") : [];
          paramDesigns = paramDesignsArr[0] ? paramDesignsArr[0] : "";
          paramDesignsSelected = paramDesigns.split(",").filter((n) => n)
            ? [...new Set(paramDesigns.split(","))]
                .filter((n) => n)
                .map((item) => ({
                  value: item,
                  label: ModelDesigns.find((opt) => opt.value === item)
                    ? ModelDesigns.find((opt) => opt.value === item).label
                    : "",
                }))
            : [];
        }

        if (
          !(
            searchQuery &&
            searchQuery !== "" &&
            !(
              EnTitle.toLowerCase().includes(searchQuery.toLowerCase()) ||
              PageName.toLowerCase().includes(searchQuery.toLowerCase()) ||
              Title.includes(searchQuery) ||
              WebsitePageId?.toString().includes(searchQuery?.toString())
            )
          )
        ) {
          pageItemsLists.push(
            <li
              className={
                searchQuery &&
                searchQuery !== "" &&
                !(
                  EnTitle.toLowerCase().includes(searchQuery.toLowerCase()) ||
                  PageName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                  Title.includes(searchQuery) ||
                  WebsitePageId?.toString().includes(searchQuery?.toString())
                )
                  ? "list_item_disappear"
                  : `${PageTypeId === 5502 ? "Curtain_item" : "Product_item"}`
              }
              key={"pageItems" + i}
              pageitems_id={i}
            >
              <span className="li_label">Page ID:{WebsitePageId}</span>
              <div className="pageItems_small_inputs 1">
                <label className="input">
                  <input
                    type="text"
                    pageitems_text_id="PageName"
                    pageitems_id={i}
                    defaultValue={PageName}
                    onChange={(e) => textChanged(e)}
                    placeholder="Type Something..."
                  />
                  <span className="input__label">Page Name</span>
                </label>
                <label className="input">
                  <input
                    type="text"
                    pageitems_text_id="LinkName"
                    pageitems_id={i}
                    defaultValue={LinkName}
                    onChange={(e) => textChanged(e)}
                    placeholder="Link Something..."
                  />
                  <span className="input__label">Page Link</span>
                </label>
                <label className="input">
                  <input
                    type="text"
                    pageitems_text_id="Title"
                    pageitems_id={i}
                    defaultValue={Title}
                    onChange={(e) => textChanged(e)}
                    placeholder="Type Something..."
                  />
                  <span className="input__label">FA Title</span>
                </label>
                <label className="input">
                  <input
                    type="text"
                    pageitems_text_id="EnTitle"
                    pageitems_id={i}
                    defaultValue={EnTitle}
                    onChange={(e) => textChanged(e)}
                    placeholder="Type Something..."
                  />
                  <span className="input__label">EN Title</span>
                </label>
                <label className="input">
                  <input
                    type="text"
                    className="dir_rtl"
                    pageitems_text_id="Description"
                    pageitems_id={i}
                    defaultValue={Description}
                    onChange={(e) => textChanged(e)}
                    placeholder="شروع به نوشتن کنید..."
                  />
                  <span className="input__label">Desc FA</span>
                </label>
                <label className="input">
                  <input
                    type="text"
                    pageitems_text_id="DescriptionEn"
                    pageitems_id={i}
                    defaultValue={DescriptionEn}
                    onChange={(e) => textChanged(e)}
                    placeholder="Type Something..."
                  />
                  <span className="input__label">Desc EN</span>
                </label>
              </div>
              <div className="pageItems_small_inputs 2">
                <div className="select_container">
                  <span className="input__label">Page Type</span>
                  <Select
                    className="select"
                    placeholder={"Please Select"}
                    // portal={document.body}
                    dropdownPosition="bottom"
                    dropdownHandle={false}
                    dropdownGap={0}
                    values={selectedPageType}
                    onDropdownOpen={() => {
                      let temp1 = window.scrollY;
                      window.scrollTo(window.scrollX, window.scrollY + 1);
                      setTimeout(() => {
                        let temp2 = window.scrollY;
                        if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                      }, 100);
                    }}
                    dropdownRenderer={({ props, state, methods }) => (
                      <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                    )}
                    contentRenderer={({ props, state, methods }) => (
                      <CustomControl props={props} state={state} methods={methods} />
                    )}
                    onChange={(selected) => {
                      if (selected.length) {
                        setSelection(i, "PageTypeId", selected[0].value);
                      }
                    }}
                    options={PageTypeOptions}
                  />
                </div>
                {PageTypeId === 5502 && (
                  <label className="input" style={{ width: "100%", minWidth: 200 }}>
                    <input
                      type="text"
                      pageitems_text_id="Price"
                      pageitems_id={i}
                      defaultValue={Price}
                      onChange={(e) => numberChanged(e)}
                      placeholder="Type Something..."
                    />
                    <span className="input__label">Price</span>
                  </label>
                )}
                {PageTypeId === 5502 && (
                  <label className="input" style={{ width: "100%", minWidth: 200 }}>
                    <input
                      type="text"
                      pageitems_text_id="DiscountPrice"
                      pageitems_id={i}
                      defaultValue={DiscountPrice}
                      onChange={(e) => numberChanged(e)}
                      placeholder="Type Something..."
                    />
                    <span className="input__label">
                      Discount Price {DiscountPercent ? "(" + DiscountPercent + "%)" : ""}
                    </span>
                  </label>
                )}
                <div className="select_container">
                  <span className="input__label">Child View</span>
                  <Select
                    className="select"
                    placeholder={"Please Select"}
                    dropdownPosition="bottom"
                    dropdownHandle={false}
                    dropdownGap={0}
                    clearable={true}
                    values={selectedChildView}
                    onDropdownOpen={() => {
                      let temp1 = window.scrollY;
                      window.scrollTo(window.scrollX, window.scrollY + 1);
                      setTimeout(() => {
                        let temp2 = window.scrollY;
                        if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                      }, 100);
                    }}
                    dropdownRenderer={({ props, state, methods }) => (
                      <CustomDropdown props={props} state={state} methods={methods} />
                    )}
                    contentRenderer={({ props, state, methods }) => (
                      <CustomControl props={props} state={state} methods={methods} />
                    )}
                    onChange={(selected) => {
                      if (selected.length) {
                        setSelection(i, "ShowWithChild", selected[0].value);
                      }
                    }}
                    onClearAll={() => {
                      setSelection(i, "ShowWithChild", null);
                    }}
                    options={ChildViewOptions}
                  />
                </div>
                {PageTypeId === 5501 && (
                  <label className="input">
                    <input
                      type="number"
                      pageitems_text_id="ColumnCount"
                      pageitems_id={i}
                      defaultValue={ColumnCount}
                      onChange={(e) => numberChanged(e)}
                      placeholder="Type Something..."
                    />
                    <span className="input__label">Column Count</span>
                  </label>
                )}
              </div>
              <div className="pageItems_large_inputs">
                <label className="input editor_container">
                  <ReactQuill
                    theme="snow"
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, false] }],
                        ["bold", "italic", "underline", "strike", "blockquote"],
                        [
                          { list: "ordered" },
                          { list: "bullet" },
                          { indent: "-1" },
                          { indent: "+1" },
                        ],
                        ["link", "image"],
                        ["clean"],
                      ],
                    }}
                    formats={[
                      "header",
                      "bold",
                      "italic",
                      "underline",
                      "strike",
                      "blockquote",
                      "list",
                      "bullet",
                      "indent",
                      "link",
                      "image",
                    ]}
                    defaultValue={HtmlContent}
                    onChange={(content, delta, source, editor) => {
                      textEditorChanged(content?.toString(), i, "HtmlContent");
                    }}
                  ></ReactQuill>

                  <span className="input__label">FA HtmlContent</span>
                </label>
                <div className="input_file">
                  <label className="input_file_label">Main Photo</label>
                  <input
                    type="file"
                    accept="image/*"
                    pageitems_text_id="ImageFile"
                    pageitems_id={i}
                    multiple={false}
                    onChange={(e) => updatePicture(e)}
                  />
                  <span className="input_file_img">
                    <img
                      className="img-fluid"
                      src={imgUrl(ImageUrl)}
                      alt=""
                    />
                  </span>
                </div>
              </div>
              <div className="pageItems_large_inputs">
                <label className="input editor_container">
                  <ReactQuill
                    theme="snow"
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, false] }],
                        ["bold", "italic", "underline", "strike", "blockquote"],
                        [
                          { list: "ordered" },
                          { list: "bullet" },
                          { indent: "-1" },
                          { indent: "+1" },
                        ],
                        ["link", "image"],
                        ["clean"],
                      ],
                    }}
                    formats={[
                      "header",
                      "bold",
                      "italic",
                      "underline",
                      "strike",
                      "blockquote",
                      "list",
                      "bullet",
                      "indent",
                      "link",
                      "image",
                    ]}
                    defaultValue={HtmlEnContent}
                    onChange={(content, delta, source, editor) => {
                      textEditorChanged(content?.toString(), i, "HtmlEnContent");
                    }}
                  ></ReactQuill>

                  <span className="input__label">EN HtmlContent</span>
                </label>
                <div className="input_file">
                  <label className="input_file_label">Fabric Photo</label>
                  <input
                    type="file"
                    accept="image/*"
                    pageitems_text_id="MainImageFile"
                    pageitems_id={i}
                    multiple={false}
                    onChange={(e) => updatePicture(e)}
                  />
                  <span className="input_file_img">
                    <img
                      className="img-fluid"
                      src={imgUrl(MainImageUrl)}
                      alt=""
                    />
                  </span>
                </div>
              </div>

              <div className="pageItems_small_inputs 3">
                <button
                  className="btn btn-success mt-4 mb-2"
                  pageitems_id={i}
                  onClick={(e) => updatePageItems(e)}
                >
                  Update Page
                </button>

                <button
                  className="btn btn-danger mt-4 mb-2"
                  pageitems_id={i}
                  onClick={(e) => deletePageItems(WebsitePageId)}
                >
                  Delete Page
                </button>

                {PageTypeId === 5502 &&
                  (Object.keys(Fabrics).length > 0 || Object.keys(AccColors).length > 0) && (
                    <div>
                      <button
                        className="btn btn-primary mt-4 mb-2"
                        pageitems_id={i}
                        ref={sortFabric}
                        onClick={() => {
                          sortFabric.current.setAttribute("disabled", "disabled");
                          // if(i===0){
                          let tempArr = paramDesignsSelected.map((el) => el["label"]);
                          if (tempArr.length) {
                            let fillteredFabrics = tempArr.reduce(
                              (result, el) => ({ ...result, [el]: Fabrics[el] }),
                              {}
                            );
                            Object.keys(fillteredFabrics).forEach((key) =>
                              fillteredFabrics[key] === undefined
                                ? delete fillteredFabrics[key]
                                : {}
                            );

                            setFabricsDragList(fillteredFabrics);
                            setAccColorsDragList(AccColors);
                          } else {
                            // console.log(Fabrics);
                            setFabricsDragList(Fabrics);
                            setAccColorsDragList(AccColors);
                          }
                          setParameters(
                            JSON.parse(
                              Parameters === undefined ||
                                Parameters === null ||
                                Parameters === "undefined" ||
                                Parameters === "null" ||
                                Parameters === ""
                                ? "{}"
                                : Parameters
                            )
                          );
                          setRefIndex(i);
                          setShowFabrics2(true);
                        }}
                      >
                        Sort
                      </button>
                    </div>
                  )}
                {PageTypeId === 5502 &&
                  Object.keys(Fabrics).length === 0 &&
                  Object.keys(AccColors).length === 0 && (
                    <div>
                      <button
                        className="btn btn-primary mt-4 mb-2"
                        pageitems_id={i}
                        onClick={() => {
                          console.log(`selectedModel[0]`, selectedModel[0]);
                          if (selectedModel[0]) {
                            getFabrics(i, selectedModel[0].value);
                          }
                        }}
                      >
                        Get Fabrics
                      </button>
                    </div>
                  )}
                {PageTypeId === 5502 && (
                  <div>
                    <button
                      className="btn clear_input"
                      pageitems_id={i}
                      onClick={(e) => clearField(e, i, "Parameters")}
                    >
                      Clear Sort
                    </button>
                  </div>
                )}
              </div>

              <div className="pageItems_small_inputs pageItems_grow_inputs 4">
                <label className="input pageItem_input_clearable">
                  <input
                    type="text"
                    pageitems_text_id="Link"
                    pageitems_id={i}
                    value={UrlLink}
                    onChange={(e) => textChanged(e)}
                    placeholder="Select Below"
                  />
                  <span className="input__label">Link(Model/Product ID)</span>
                  <button
                    className="clear_input"
                    pageitems_id={i}
                    onClick={(e) => clearField(e, i, "Link")}
                  >
                    Clear
                  </button>
                </label>
                <div className={PageTypeId === 5502 ? "select_container" : "noDisplay"}>
                  <span className="input__label">Link(Model)</span>
                  <Select
                    className="select"
                    placeholder={"Please Select"}
                    // portal={document.body}
                    dropdownPosition="bottom"
                    dropdownHandle={false}
                    dropdownGap={0}
                    values={selectedModel}
                    onDropdownOpen={() => {
                      let temp1 = window.scrollY;
                      window.scrollTo(window.scrollX, window.scrollY + 1);
                      setTimeout(() => {
                        let temp2 = window.scrollY;
                        if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                      }, 100);
                    }}
                    dropdownRenderer={({ props, state, methods }) => (
                      <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                    )}
                    contentRenderer={({ props, state, methods }) => (
                      <CustomControl props={props} state={state} methods={methods} />
                    )}
                    onChange={(selected) => {
                      if (selected.length) {
                        setSelection(i, "Link", selected[0].value);
                        getFabrics(i, selected[0].value);
                      }
                    }}
                    options={models}
                  />
                </div>
                <div className={PageTypeId === 5501 ? "select_container" : "noDisplay"}>
                  <span className="input__label">Link(Product)</span>
                  <Select
                    className="select"
                    placeholder={"Please Select"}
                    // portal={document.body}
                    dropdownPosition="bottom"
                    dropdownHandle={false}
                    dropdownGap={0}
                    values={selectedProduct}
                    onDropdownOpen={() => {
                      let temp1 = window.scrollY;
                      window.scrollTo(window.scrollX, window.scrollY + 1);
                      setTimeout(() => {
                        let temp2 = window.scrollY;
                        if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                      }, 100);
                    }}
                    dropdownRenderer={({ props, state, methods }) => (
                      <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                    )}
                    contentRenderer={({ props, state, methods }) => (
                      <CustomControl props={props} state={state} methods={methods} />
                    )}
                    onChange={(selected) => {
                      if (selected.length) {
                        setSelection(i, "Link", selected[0].value);
                        getFabrics(i, selected[0].value);
                      }
                    }}
                    options={products}
                  />
                </div>
                <div className="select_container">
                  <span className="input__label">Page Type</span>
                  <Select
                    className="select"
                    placeholder={"Please Select"}
                    // portal={document.body}
                    dropdownPosition="bottom"
                    dropdownHandle={false}
                    dropdownGap={0}
                    clearable={true}
                    values={selectedRelatedPage}
                    onDropdownOpen={() => {
                      let temp1 = window.scrollY;
                      window.scrollTo(window.scrollX, window.scrollY + 1);
                      setTimeout(() => {
                        let temp2 = window.scrollY;
                        if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                      }, 100);
                    }}
                    dropdownRenderer={({ props, state, methods }) => (
                      <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                    )}
                    contentRenderer={({ props, state, methods }) => (
                      <CustomControl props={props} state={state} methods={methods} />
                    )}
                    onChange={(selected) => {
                      if (selected.length) {
                        setSelection(i, "RelatedPage", selected[0].value);
                      }
                    }}
                    onClearAll={() => {
                      setSelection(i, "RelatedPage", null);
                    }}
                    options={PageTypeId === 5501 ? relatedPages : curtainRelatedPages}
                  />
                </div>
              </div>
              <div className="pageItems_large_inputs pageItems_grow">
                <label className="input readOnly pageItem_input_clearable">
                  <input
                    readOnly
                    type="text"
                    pageitems_text_id="QueryString"
                    pageitems_id={i}
                    value={QueryString}
                    onChange={(e) => textChanged(e)}
                    placeholder="Type Something..."
                  />
                  <span className="input__label">QueryString</span>
                  <button
                    className="clear_input"
                    pageitems_id={i}
                    onClick={(e) => clearField(e, i, "QueryString")}
                  >
                    Clear
                  </button>
                </label>
                <div className="pageItems_filters_container">
                  <div className="select_container multi_select_container">
                    <span className="input__label">QueryString(Colors)</span>
                    <Select
                      className="select"
                      placeholder={"Please Select"}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      multi={true}
                      values={QueryString ? paramColorsSelected : []}
                      onDropdownOpen={() => {
                        let temp1 = window.scrollY;
                        window.scrollTo(window.scrollX, window.scrollY + 1);
                        setTimeout(() => {
                          let temp2 = window.scrollY;
                          if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                        }, 100);
                      }}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdownMulti props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControlMulti props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        setMultiSelection(
                          i,
                          "QueryString",
                          "colors=",
                          selected.map((obj) => obj.label)
                        );
                      }}
                      options={sewingColors}
                    />
                  </div>
                  <div className="select_container multi_select_container">
                    <span className="input__label">QueryString(Patterns)</span>
                    <Select
                      className="select"
                      placeholder={"Please Select"}
                      // portal={document.body}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      multi={true}
                      values={QueryString ? paramPatternsSelected : []}
                      onDropdownOpen={() => {
                        let temp1 = window.scrollY;
                        window.scrollTo(window.scrollX, window.scrollY + 1);
                        setTimeout(() => {
                          let temp2 = window.scrollY;
                          if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                        }, 100);
                      }}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdownMulti props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControlMulti props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        setMultiSelection(
                          i,
                          "QueryString",
                          "patterns=",
                          selected.map((obj) => obj.label)
                        );
                      }}
                      options={sewingPatterns}
                    />
                  </div>
                  <div className="select_container multi_select_container">
                    <span className="input__label">QueryString(Types)</span>
                    <Select
                      className="select"
                      placeholder={"Please Select"}
                      // portal={document.body}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      multi={true}
                      values={QueryString ? paramTypesSelected : []}
                      onDropdownOpen={() => {
                        let temp1 = window.scrollY;
                        window.scrollTo(window.scrollX, window.scrollY + 1);
                        setTimeout(() => {
                          let temp2 = window.scrollY;
                          if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                        }, 100);
                      }}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdownMulti props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControlMulti props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        setMultiSelection(
                          i,
                          "QueryString",
                          "type=",
                          selected.map((obj) => obj.label)
                        );
                      }}
                      options={sewingTypes}
                    />
                  </div>
                  <div className="select_container multi_select_container">
                    <span className="input__label">QueryString(Prices)</span>
                    <Select
                      className="select"
                      placeholder={"Please Select"}
                      // portal={document.body}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      multi={true}
                      values={QueryString ? paramPricesSelected : []}
                      onDropdownOpen={() => {
                        let temp1 = window.scrollY;
                        window.scrollTo(window.scrollX, window.scrollY + 1);
                        setTimeout(() => {
                          let temp2 = window.scrollY;
                          if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                        }, 100);
                      }}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdownMulti props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControlMulti props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        setMultiSelection(
                          i,
                          "QueryString",
                          "prices=",
                          selected.map((obj) => obj.value?.toString())
                        );
                      }}
                      options={sewingPrices}
                    />
                  </div>
                  {ModelDesigns.length > 0 && (
                    <div className="select_container multi_select_container">
                      <span className="input__label">QueryString(Designs)</span>
                      <Select
                        className="select"
                        placeholder={"Please Select"}
                        // portal={document.body}
                        dropdownPosition="bottom"
                        dropdownHandle={false}
                        dropdownGap={0}
                        multi={true}
                        values={QueryString ? paramDesignsSelected : []}
                        onDropdownOpen={() => {
                          let temp1 = window.scrollY;
                          window.scrollTo(window.scrollX, window.scrollY + 1);
                          setTimeout(() => {
                            let temp2 = window.scrollY;
                            if (temp2 === temp1)
                              window.scrollTo(window.scrollX, window.scrollY - 1);
                          }, 100);
                        }}
                        dropdownRenderer={({ props, state, methods }) => (
                          <CustomDropdownMulti props={props} state={state} methods={methods} />
                        )}
                        contentRenderer={({ props, state, methods }) => (
                          <CustomControlMulti props={props} state={state} methods={methods} />
                        )}
                        onChange={(selected) => {
                          setMultiSelection(
                            i,
                            "QueryString",
                            "designs=",
                            selected.map((obj) => obj.value?.toString())
                          );
                        }}
                        options={ModelDesigns}
                      />
                    </div>
                  )}
                </div>

                {PageTypeId === 5501 && (
                  <div className="pageItems_filters_container">
                    <div className="select_container multi_select_container">
                      <span className="input__label">QueryString(Opacity)</span>
                      <Select
                        className="select"
                        placeholder={"Please Select"}
                        // portal={document.body}
                        dropdownPosition="bottom"
                        dropdownHandle={false}
                        dropdownGap={0}
                        multi={true}
                        values={QueryString ? paramOpacitySelected : []}
                        onDropdownOpen={() => {
                          let temp1 = window.scrollY;
                          window.scrollTo(window.scrollX, window.scrollY + 1);
                          setTimeout(() => {
                            let temp2 = window.scrollY;
                            if (temp2 === temp1)
                              window.scrollTo(window.scrollX, window.scrollY - 1);
                          }, 100);
                        }}
                        dropdownRenderer={({ props, state, methods }) => (
                          <CustomDropdownMulti props={props} state={state} methods={methods} />
                        )}
                        contentRenderer={({ props, state, methods }) => (
                          <CustomControlMulti props={props} state={state} methods={methods} />
                        )}
                        onChange={(selected) => {
                          setMultiSelection(
                            i,
                            "QueryString",
                            "opacity=",
                            selected.map((obj) => obj.label)
                          );
                        }}
                        options={sewingOpacity}
                      />
                    </div>
                    <div className="select_container multi_select_container">
                      <span className="input__label">QueryString(Size)</span>
                      <Select
                        className="select"
                        placeholder={"Please Select"}
                        // portal={document.body}
                        dropdownPosition="bottom"
                        dropdownHandle={false}
                        dropdownGap={0}
                        multi={true}
                        values={QueryString ? paramSizeSelected : []}
                        onDropdownOpen={() => {
                          let temp1 = window.scrollY;
                          window.scrollTo(window.scrollX, window.scrollY + 1);
                          setTimeout(() => {
                            let temp2 = window.scrollY;
                            if (temp2 === temp1)
                              window.scrollTo(window.scrollX, window.scrollY - 1);
                          }, 100);
                        }}
                        dropdownRenderer={({ props, state, methods }) => (
                          <CustomDropdownMulti props={props} state={state} methods={methods} />
                        )}
                        contentRenderer={({ props, state, methods }) => (
                          <CustomControlMulti props={props} state={state} methods={methods} />
                        )}
                        onChange={(selected) => {
                          setMultiSelection(
                            i,
                            "QueryString",
                            "size=",
                            selected.map((obj) => obj.value?.toString())
                          );
                        }}
                        options={sewingSize}
                      />
                    </div>
                    <div className="select_container multi_select_container">
                      <span className="input__label">QueryString(HangingStyle)</span>
                      <Select
                        className="select"
                        placeholder={"Please Select"}
                        dropdownPosition="bottom"
                        dropdownHandle={false}
                        dropdownGap={0}
                        multi={true}
                        values={QueryString ? paramHangingStyleSelected : []}
                        onDropdownOpen={() => {
                          let temp1 = window.scrollY;
                          window.scrollTo(window.scrollX, window.scrollY + 1);
                          setTimeout(() => {
                            let temp2 = window.scrollY;
                            if (temp2 === temp1)
                              window.scrollTo(window.scrollX, window.scrollY - 1);
                          }, 100);
                        }}
                        dropdownRenderer={({ props, state, methods }) => (
                          <CustomDropdownMulti props={props} state={state} methods={methods} />
                        )}
                        contentRenderer={({ props, state, methods }) => (
                          <CustomControlMulti props={props} state={state} methods={methods} />
                        )}
                        onChange={(selected) => {
                          console.log(`selected`, selected);
                          setMultiSelection(
                            i,
                            "QueryString",
                            "hangingStyle=",
                            selected.map((obj) => obj.label?.toString())
                          );
                        }}
                        options={sewingHangingStyle}
                      />
                    </div>
                  </div>
                )}
                <div className="pageItems_filters_container pageItems_children_container">
                  <div className="select_container">
                    <span className="input__label">Children</span>
                    <Select
                      className="select"
                      placeholder={"Please Select"}
                      // portal={document.body}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      multi={true}
                      clearable={true}
                      values={selectedChildren}
                      onDropdownOpen={() => {
                        let temp1 = window.scrollY;
                        window.scrollTo(window.scrollX, window.scrollY + 1);
                        setTimeout(() => {
                          let temp2 = window.scrollY;
                          if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                        }, 100);
                      }}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdownMultiWithSearch
                          props={props}
                          state={state}
                          methods={methods}
                        />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControlMulti props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        if (selected.length) {
                          setSelection(i, "ChildPages", selected);
                        }
                      }}
                      onClearAll={() => {
                        setSelection(i, "ChildPages", []);
                      }}
                      options={childrenPageItems}
                    />
                  </div>
                </div>
              </div>
            </li>
          );
        }
        resolve();
      });
    }
    Promise.all(promiseArr).then(() => {
      // setPageItemsList(pageItemsLists);
      setPageItemsList(pageItemsLists);
      setPageCount(Math.ceil(pageItemsLists.length / itemsPerPage));
    });
  }

  useEffect(() => {
    if (!parameters) {
      return;
    }

    const paramsString = JSON.stringify(parameters);
    if (lastParametersRef.current === paramsString) {
      return;
    }
    lastParametersRef.current = paramsString;

    // Clear any existing timeout
    if (fabricLoadingTimeoutRef.current) {
      clearTimeout(fabricLoadingTimeoutRef.current);
    }

    // Clear any existing safety timeout
    if (fabricLoadingSafetyTimeoutRef.current) {
      clearTimeout(fabricLoadingSafetyTimeoutRef.current);
    }

    // Set a safety timeout to ensure loading is reset even if something goes wrong
    // This timeout will ALWAYS be set to ensure loading doesn't get stuck
    fabricLoadingSafetyTimeoutRef.current = setTimeout(() => {
      console.log("Safety timeout triggered - resetting loading");
      setFabricIsLoading(false);
      fabricLoadingPromiseRef.current = null;
      isDragInProgressRef.current = false;
    }, 3000); // 3 seconds safety timeout - MUST be longer than the main timeout + processing time

    // Don't set loading here - it should only be set in drag functions
    // This prevents useEffect from re-triggering loading on every parameter change

    fabricLoadingTimeoutRef.current = setTimeout(() => {
      console.log(parameters);
      const fabricList = [];
      const designList = [];
      const AccList = [];
      const AccColorList = [];
      const tempDesignOrderList = [];
      const tempAccDesignOrderList = [];
      let promiseArr = [];
      let promiseArr2 = [];
      let tempFabrics = JSON.parse(JSON.stringify(fabricsDragList));
      let tempColors = JSON.parse(JSON.stringify(AccColorsDragList));
      console.log(tempFabrics, tempColors);

      Object.keys(AccColorsDragList).forEach((key, index) => {
        promiseArr2[index] = new Promise((resolve, reject) => {
          // console.log(AccColorsDragList);
          // Find first valid item to get DesignCode
          let firstValidItem = AccColorsDragList[key]?.find((item) => item && item["DesignCode"]);
          if (!firstValidItem) {
            console.warn("No valid item found in AccColorsDragList[key]:", key);
            resolve();
            return;
          }
          let DesignCode = firstValidItem["DesignCode"]?.toString();
          let designOrderSelected =
            parameters["AccDesigns"] &&
            parameters["AccDesigns"][DesignCode] &&
            parameters["AccDesigns"][DesignCode]["order"]
              ? parameters["AccDesigns"][DesignCode]["order"]
              : -1;

          const fabric = [];
          tempColors[key] = [];
          let promiseArr3 = [];
          AccColorsDragList[key].forEach((obj, index2) => {
            promiseArr3[index2] = new Promise((resolve, reject) => {
              // Skip if obj is null or undefined
              if (!obj || !obj["DetailId"]) {
                resolve();
                return;
              }

              let DetailId = obj["DetailId"];
              // let tempColor = obj["ColorHtmlCode"] !== "" ? obj["ColorHtmlCode"] : "#e2e2e2";
              let ColorENName = obj["ColorENName"] || "";
              let fabricOrderSelected =
                parameters["AccColors"] &&
                parameters["AccColors"][DetailId] &&
                parameters["AccColors"][DetailId]["order"]
                  ? parameters["AccColors"][DetailId]["order"]
                  : -1;
              let PhotoPath = "";
              let photoArr = obj["Photos"] || [];
              if (Array.isArray(photoArr)) {
                photoArr.forEach((photoObj) => {
                  if (photoObj && photoObj["PhotoTypeId"] === 4702)
                    PhotoPath = photoObj["PhotoUrl"];
                });
              }
              if (fabricOrderSelected !== -1 && !fabric[fabricOrderSelected]) {
                tempColors[key][fabricOrderSelected] = obj;
                fabric[fabricOrderSelected] = (
                  <GridItem key={index2} className="drag_grid">
                    <div
                      style={{
                        width: "90%",
                        height: "100%",
                      }}
                      className="radio_group"
                    >
                      <label>
                        <div className="frame_img">
                          <img
                            className={`img-fluid`}
                            src={imgUrl(PhotoPath)}
                            alt=""
                          />
                        </div>
                      </label>
                      <div className={`fabric_name_container`}>
                        <h1>{ColorENName}</h1>
                      </div>
                    </div>
                  </GridItem>
                );
              } else {
                let index = fabric.findIndex(Object.is.bind(null, undefined));
                let pushIndex = index === -1 ? fabric.length : index;
                tempColors[key][pushIndex] = obj;
                fabric[pushIndex] = (
                  <GridItem key={index2} className="drag_grid">
                    <div
                      style={{
                        width: "90%",
                        height: "100%",
                      }}
                      className="radio_group"
                    >
                      <label>
                        <div className="frame_img">
                          <img
                            className={`img-fluid`}
                            src={imgUrl(PhotoPath)}
                            alt=""
                          />
                        </div>
                      </label>
                      <div className={`fabric_name_container`}>
                        <h1>{ColorENName}</h1>
                      </div>
                    </div>
                  </GridItem>
                );
              }
              resolve();
            });
          });
          Promise.all(promiseArr3).then(() => {
            tempColors[key].filter((n) => n);
            if (designOrderSelected !== -1 && !AccList[designOrderSelected]) {
              // Find first valid item to get DesignCode
              let firstValidItem = AccColorsDragList[key]?.find(
                (item) => item && item["DesignCode"]
              );
              if (firstValidItem && firstValidItem["DesignCode"]) {
                tempAccDesignOrderList[designOrderSelected] = firstValidItem["DesignCode"];
              }
              AccList[designOrderSelected] = (
                <GridItem key={index} className="drag_grid">
                  <div className={`material_detail`} key={"fabric" + key}>
                    <span>
                      {"DESIGN NAME"}: {key}
                    </span>
                  </div>
                </GridItem>
              );
            } else {
              let index = AccList.findIndex(Object.is.bind(null, undefined));
              let pushIndex = index === -1 ? AccList.length : index;
              // Find first valid item to get DesignCode
              let firstValidItem = AccColorsDragList[key]?.find(
                (item) => item && item["DesignCode"]
              );
              if (firstValidItem && firstValidItem["DesignCode"]) {
                tempAccDesignOrderList[pushIndex] = firstValidItem["DesignCode"];
              }
              AccList[pushIndex] = (
                <GridItem key={pushIndex} className="drag_grid">
                  <div className={`material_detail`} key={"fabric" + key}>
                    <span>
                      {"DESIGN NAME"}: {key}
                    </span>
                  </div>
                </GridItem>
              );
            }
            if (designOrderSelected !== -1 && !AccColorList[designOrderSelected]) {
              AccColorList[index] = (
                <div className={`material_detail`} key={"fabric" + key}>
                  <div className={`material_traits`}>
                    <span>
                      {"DESIGN NAME"}: {key}
                    </span>
                  </div>
                  <GridContextProvider
                    onChange={(sourceId, sourceIndex, targetIndex, targetId) =>
                      dragOnChange2(sourceId, sourceIndex, targetIndex, targetId, tempColors, key)
                    }
                  >
                    <GridDropZone
                      id="Accitems"
                      boxesPerRow={4}
                      rowHeight={155}
                      style={{ height: "312px" }}
                      className="drag_grid_container"
                    >
                      {fabric.filter((n) => n)}
                    </GridDropZone>
                  </GridContextProvider>
                </div>
              );
              resolve();
            } else {
              let index = AccColorList.findIndex(Object.is.bind(null, undefined));
              let pushIndex = index === -1 ? AccColorList.length : index;
              AccColorList[pushIndex] = (
                <div className={`material_detail`} key={"fabric" + key}>
                  <div className={`material_traits`}>
                    <span>
                      {"DESIGN NAME"}: {key}
                    </span>
                  </div>
                  <GridContextProvider
                    onChange={(sourceId, sourceIndex, targetIndex, targetId) =>
                      dragOnChange2(sourceId, sourceIndex, targetIndex, targetId, tempColors, key)
                    }
                  >
                    <GridDropZone
                      id="Accitems"
                      boxesPerRow={4}
                      rowHeight={155}
                      style={{ height: "312px" }}
                      className="drag_grid_container"
                    >
                      {fabric.filter((n) => n)}
                    </GridDropZone>
                  </GridContextProvider>
                </div>
              );
              resolve();
            }
          });
        });
      });

      Object.keys(fabricsDragList).forEach((key, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          console.log(fabricsDragList, fabricsDragList[key], index);

          // Check if fabricsDragList[key] exists and has items
          if (
            !fabricsDragList[key] ||
            !Array.isArray(fabricsDragList[key]) ||
            fabricsDragList[key].length === 0
          ) {
            console.warn("Invalid fabricsDragList key:", key);
            resolve();
            return;
          }

          // Find first valid item to get DesignCode
          let firstValidItem = fabricsDragList[key].find((item) => item && item["DesignCode"]);
          if (!firstValidItem) {
            console.warn("No valid item found in fabricsDragList[key]:", key);
            resolve();
            return;
          }

          let DesignCode = firstValidItem["DesignCode"]?.toString();
          let designTypeSelected =
            parameters["Designs"] &&
            parameters["Designs"][DesignCode] &&
            parameters["Designs"][DesignCode]["type"]
              ? [
                  {
                    value: parameters["Designs"][DesignCode]["type"]?.toString(),
                    label: DesignType.find(
                      (opt) => opt.value === parameters["Designs"][DesignCode]["type"]?.toString()
                    )["label"],
                  },
                ]
              : [];

          let designOrderSelected =
            parameters["Designs"] &&
            parameters["Designs"][DesignCode] &&
            parameters["Designs"][DesignCode]["order"]
              ? parameters["Designs"][DesignCode]["order"]
              : -1;
          let designOnlyOneSelected =
            parameters["Designs"] &&
            parameters["Designs"][DesignCode] &&
            parameters["Designs"][DesignCode]["onlyOne"]
              ? [
                  {
                    value: "one",
                    label: DesignOne.find((opt) => opt.value === "one")["label"],
                  },
                ]
              : [
                  {
                    value: "none",
                    label: DesignOne.find((opt) => opt.value === "none")["label"],
                  },
                ];
          const fabric = [];
          tempFabrics[key] = [];

          for (let j = 0; j < fabricsDragList[key].length; j++) {
            // Skip if item is null or undefined
            const currentItem = fabricsDragList[key][j];
            if (!currentItem || typeof currentItem !== "object" || !currentItem.FabricId) {
              continue;
            }

            let FabricId = currentItem.FabricId;
            let fabricOrderSelected =
              parameters["Fabrics"] &&
              parameters["Fabrics"][FabricId] &&
              parameters["Fabrics"][FabricId]["order"]
                ? parameters["Fabrics"][FabricId]["order"]
                : -1;

            let PhotoPath = "";
            if (currentItem["FabricPhotos"] && Array.isArray(currentItem["FabricPhotos"])) {
              currentItem["FabricPhotos"].forEach((obj) => {
                if (obj && obj["PhotoTypeId"] === 4702) PhotoPath = obj["PhotoUrl"];
              });
            }
            let ColorEnName = currentItem["ColorEnName"] || "";
            // console.log(fabricOrderSelected,FabricId);
            if (fabricOrderSelected !== -1 && !fabric[fabricOrderSelected]) {
              tempFabrics[key][fabricOrderSelected] = currentItem;
              fabric[fabricOrderSelected] = (
                <GridItem key={j} className="drag_grid">
                  <div
                    style={{
                      width: "90%",
                      height: "100%",
                    }}
                    className="radio_group"
                  >
                    <label>
                      <div className="frame_img">
                        <img
                          className={`img-fluid`}
                          src={imgUrl(PhotoPath)}
                          alt=""
                        />
                      </div>
                    </label>
                    <div className={`fabric_name_container`}>
                      <h1>{ColorEnName}</h1>
                    </div>
                  </div>
                </GridItem>
              );
            } else {
              let index = fabric.findIndex(Object.is.bind(null, undefined));
              let pushIndex = index === -1 ? fabric.length : index;
              tempFabrics[key][pushIndex] = currentItem;
              fabric[pushIndex] = (
                <GridItem key={j} className="drag_grid">
                  <div
                    style={{
                      width: "90%",
                      height: "100%",
                    }}
                    className="radio_group"
                  >
                    <label>
                      <div className="frame_img">
                        <img
                          className={`img-fluid`}
                          src={imgUrl(PhotoPath)}
                          alt=""
                        />
                      </div>
                    </label>
                    <div className={`fabric_name_container`}>
                      <h1>{ColorEnName}</h1>
                    </div>
                  </div>
                </GridItem>
              );
            }
          }
          tempFabrics[key].filter((n) => n);
          console.log(fabric, tempFabrics);

          if (designOrderSelected !== -1 && !designList[designOrderSelected]) {
            // Find first valid item to get DesignCode
            let firstValidItem = fabricsDragList[key]?.find((item) => item && item["DesignCode"]);
            if (firstValidItem && firstValidItem["DesignCode"]) {
              tempDesignOrderList[designOrderSelected] = firstValidItem["DesignCode"];
              // console.log(tempDesignOrderList[designOrderSelected],designOrderSelected);
            }
            designList[designOrderSelected] = (
              <GridItem key={index} className="drag_grid">
                <div className={`material_detail`} key={"fabric" + key}>
                  <span>
                    {"DESIGN NAME"}: {key}
                  </span>
                </div>
                <div className="select_container">
                  <Select
                    className="select select_page_item"
                    style={{ zIndex: "9999" }}
                    placeholder={"Please Select"}
                    portal={document.body}
                    dropdownPosition="bottom"
                    dropdownHandle={false}
                    dropdownGap={0}
                    values={designTypeSelected}
                    onDropdownOpen={() => {
                      let temp1 = window.scrollY;
                      window.scrollTo(window.scrollX, window.scrollY + 1);
                      setTimeout(() => {
                        let temp2 = window.scrollY;
                        if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                      }, 100);
                    }}
                    dropdownRenderer={({ props, state, methods }) => (
                      <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                    )}
                    contentRenderer={({ props, state, methods }) => (
                      <CustomControl props={props} state={state} methods={methods} />
                    )}
                    onChange={(selected) => {
                      if (selected.length) {
                        let temp = JSON.parse(JSON.stringify(fabricDesigns2));
                        temp["refIndex"] = refIndex;
                        temp["id"] = DesignCode;
                        temp["type"] = selected[0]["value"];
                        temp["fabrics"] = tempFabrics;
                        setFabricDesigns2(temp);
                      }
                    }}
                    options={DesignType}
                  />
                </div>
                <div className="select_container select_container2">
                  <Select
                    className="select select_page_item"
                    style={{ zIndex: "9999" }}
                    placeholder={"Please Select"}
                    portal={document.body}
                    dropdownPosition="bottom"
                    dropdownHandle={false}
                    dropdownGap={0}
                    values={designOnlyOneSelected}
                    onDropdownOpen={() => {
                      let temp1 = window.scrollY;
                      window.scrollTo(window.scrollX, window.scrollY + 1);
                      setTimeout(() => {
                        let temp2 = window.scrollY;
                        if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                      }, 100);
                    }}
                    dropdownRenderer={({ props, state, methods }) => (
                      <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                    )}
                    contentRenderer={({ props, state, methods }) => (
                      <CustomControl props={props} state={state} methods={methods} />
                    )}
                    onChange={(selected) => {
                      if (selected.length) {
                        if (selected[0]["value"] === "one") {
                          let temp = JSON.parse(JSON.stringify(fabricDesigns2));
                          temp["refIndex"] = refIndex;
                          temp["id"] = DesignCode;
                          temp["onlyOne"] = true;
                          temp["fabrics"] = tempFabrics;
                          setFabricDesigns2(temp);
                        } else {
                          let temp = JSON.parse(JSON.stringify(fabricDesigns2));
                          temp["refIndex"] = refIndex;
                          temp["id"] = DesignCode;
                          temp["onlyOne"] = false;
                          temp["fabrics"] = tempFabrics;
                          setFabricDesigns2(temp);
                        }
                      }
                    }}
                    options={DesignOne}
                  />
                </div>
              </GridItem>
            );
          } else {
            let index = designList.findIndex(Object.is.bind(null, undefined));
            let pushIndex = index === -1 ? designList.length : index;
            // Find first valid item to get DesignCode
            let firstValidItem = fabricsDragList[key]?.find((item) => item && item["DesignCode"]);
            if (firstValidItem && firstValidItem["DesignCode"]) {
              tempDesignOrderList[pushIndex] = firstValidItem["DesignCode"];
              // console.log(tempDesignOrderList[pushIndex],pushIndex);
            }
            designList[pushIndex] = (
              <GridItem key={pushIndex} className="drag_grid">
                <div className={`material_detail`} key={"fabric" + key}>
                  <span>
                    {"DESIGN NAME"}: {key}
                  </span>
                </div>
                <div className="select_container">
                  <Select
                    className="select select_page_item"
                    placeholder={"Please Select"}
                    portal={document.body}
                    dropdownPosition="bottom"
                    dropdownHandle={false}
                    dropdownGap={0}
                    values={designTypeSelected}
                    onDropdownOpen={() => {
                      let temp1 = window.scrollY;
                      window.scrollTo(window.scrollX, window.scrollY + 1);
                      setTimeout(() => {
                        let temp2 = window.scrollY;
                        if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                      }, 100);
                    }}
                    dropdownRenderer={({ props, state, methods }) => (
                      <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                    )}
                    contentRenderer={({ props, state, methods }) => (
                      <CustomControl props={props} state={state} methods={methods} />
                    )}
                    onChange={(selected) => {
                      if (selected.length) {
                        let temp = JSON.parse(JSON.stringify(fabricDesigns2));
                        temp["refIndex"] = refIndex;
                        temp["id"] = DesignCode;
                        temp["type"] = selected[0]["value"];
                        temp["fabrics"] = tempFabrics;
                        setFabricDesigns2(temp);
                      }
                    }}
                    options={DesignType}
                  />
                </div>
                <div className="select_container select_container2">
                  <Select
                    className="select select_page_item"
                    style={{ zIndex: "9999" }}
                    placeholder={"Please Select"}
                    portal={document.body}
                    dropdownPosition="bottom"
                    dropdownHandle={false}
                    dropdownGap={0}
                    values={designOnlyOneSelected}
                    onDropdownOpen={() => {
                      let temp1 = window.scrollY;
                      window.scrollTo(window.scrollX, window.scrollY + 1);
                      setTimeout(() => {
                        let temp2 = window.scrollY;
                        if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                      }, 100);
                    }}
                    dropdownRenderer={({ props, state, methods }) => (
                      <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                    )}
                    contentRenderer={({ props, state, methods }) => (
                      <CustomControl props={props} state={state} methods={methods} />
                    )}
                    onChange={(selected) => {
                      if (selected.length) {
                        if (selected[0]["value"] === "one") {
                          let temp = JSON.parse(JSON.stringify(fabricDesigns2));
                          temp["refIndex"] = refIndex;
                          temp["id"] = DesignCode;
                          temp["onlyOne"] = true;
                          temp["fabrics"] = tempFabrics;
                          setFabricDesigns2(temp);
                        } else {
                          let temp = JSON.parse(JSON.stringify(fabricDesigns2));
                          temp["refIndex"] = refIndex;
                          temp["id"] = DesignCode;
                          temp["onlyOne"] = false;
                          temp["fabrics"] = tempFabrics;
                          setFabricDesigns2(temp);
                        }
                      }
                    }}
                    options={DesignOne}
                  />
                </div>
              </GridItem>
            );
          }
          // console.log(fabric);

          if (designOrderSelected !== -1 && !fabricList[designOrderSelected]) {
            fabricList[index] = (
              <div className={`material_detail`} key={"fabric" + key}>
                <div className={`material_traits`}>
                  <span>
                    {"DESIGN NAME"}: {key}
                  </span>
                </div>
                <GridContextProvider
                  onChange={(sourceId, sourceIndex, targetIndex, targetId) =>
                    dragOnChange(sourceId, sourceIndex, targetIndex, targetId, tempFabrics, key)
                  }
                >
                  <GridDropZone
                    id="items"
                    boxesPerRow={4}
                    rowHeight={155}
                    style={{ height: "465px" }}
                    className="drag_grid_container"
                  >
                    {fabric.filter((n) => n)}
                  </GridDropZone>
                </GridContextProvider>
              </div>
            );
            resolve();
          } else {
            let index = fabricList.findIndex(Object.is.bind(null, undefined));
            let pushIndex = index === -1 ? fabricList.length : index;
            fabricList[pushIndex] = (
              <div className={`material_detail`} key={"fabric" + key}>
                <div className={`material_traits`}>
                  <span>
                    {"DESIGN NAME"}: {key}
                  </span>
                </div>
                <GridContextProvider
                  onChange={(sourceId, sourceIndex, targetIndex, targetId) =>
                    dragOnChange(sourceId, sourceIndex, targetIndex, targetId, tempFabrics, key)
                  }
                >
                  <GridDropZone
                    id="items"
                    boxesPerRow={4}
                    rowHeight={155}
                    style={{ height: "465px" }}
                    className="drag_grid_container"
                  >
                    {fabric.filter((n) => n)}
                  </GridDropZone>
                </GridContextProvider>
              </div>
            );
            resolve();
          }
        });
      });

      // Check if arrays are empty to avoid Promise.all issues
      const allPromises = [...promiseArr.filter((p) => p), ...promiseArr2.filter((p) => p)];
      if (allPromises.length === 0) {
        console.log("No promises to resolve - resetting loading immediately");
        if (fabricLoadingSafetyTimeoutRef.current) {
          clearTimeout(fabricLoadingSafetyTimeoutRef.current);
          fabricLoadingSafetyTimeoutRef.current = null;
        }
        setFabricIsLoading(false);
        fabricLoadingPromiseRef.current = null;
        isDragInProgressRef.current = false;
        return;
      }

      // Add a timeout to Promise.all to ensure it doesn't hang forever
      const promiseWithTimeout = Promise.race([
        Promise.all(allPromises),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error("Promise.all timeout")), 5000)
        ),
      ]);

      fabricLoadingPromiseRef.current = promiseWithTimeout
        .then(() => {
          setDragListDesignsList([
            <GridContextProvider
              onChange={(sourceId, sourceIndex, targetIndex, targetId) =>
                dragOnChangeDesigns(
                  sourceId,
                  sourceIndex,
                  targetIndex,
                  targetId,
                  tempDesignOrderList
                )
              }
            >
              <GridDropZone
                id="designs"
                boxesPerRow={1}
                rowHeight={40}
                style={{ height: "400px" }}
                className="drag_grid_container design_drag_grid_container"
              >
                {designList.filter((n) => n)}
              </GridDropZone>
            </GridContextProvider>,
          ]);
          setDragListAccessoryColorsList([
            <GridContextProvider
              onChange={(sourceId, sourceIndex, targetIndex, targetId) =>
                dragOnChangeDesigns2(
                  sourceId,
                  sourceIndex,
                  targetIndex,
                  targetId,
                  tempAccDesignOrderList
                )
              }
            >
              <GridDropZone
                id="AccDesigns"
                boxesPerRow={1}
                rowHeight={40}
                style={{ height: "400px" }}
                className="drag_grid_container design_drag_grid_container"
              >
                {AccList.filter((n) => n)}
              </GridDropZone>
            </GridContextProvider>,
          ]);

          setDragListFabricsList(fabricList.filter((n) => n));
          setDragListAccessoryList(AccColorList.filter((n) => n));

          setFabricsDragList(tempFabrics);
          setAccColorsDragList(tempColors);
          if (fabricLoadingSafetyTimeoutRef.current) {
            clearTimeout(fabricLoadingSafetyTimeoutRef.current);
            fabricLoadingSafetyTimeoutRef.current = null;
          }
          console.log("Promise.all resolved - resetting loading");
          setFabricIsLoading(false);
          fabricLoadingPromiseRef.current = null;
          isDragInProgressRef.current = false;
          // setDesignOrderList(tempDesignOrderList);
          // setDesignOrderList(tempAccDesignOrderList);

          // console.log(tempFabrics);
        })
        .catch((error) => {
          console.error("Error in fabric loading:", error);
          if (fabricLoadingSafetyTimeoutRef.current) {
            clearTimeout(fabricLoadingSafetyTimeoutRef.current);
            fabricLoadingSafetyTimeoutRef.current = null;
          }
          console.log("Promise.all rejected or timed out - resetting loading");
          setFabricIsLoading(false);
          fabricLoadingPromiseRef.current = null;
          isDragInProgressRef.current = false;
        });
    }, 500);

    // Cleanup function to reset loading if effect is interrupted
    return () => {
      if (fabricLoadingTimeoutRef.current) {
        clearTimeout(fabricLoadingTimeoutRef.current);
        fabricLoadingTimeoutRef.current = null;
      }
      // Don't clear safety timeout in cleanup - let it run to ensure loading is reset
      // This is important because if useEffect is interrupted, we still want the safety timeout to fire
    };
  }, [JSON.stringify(parameters)]);

  function renderFabrics(refIndex, fieldName, fabrics, Parameters) {
    setFabricsList([]);
    setFabricsButtonList([]);
    // console.log(refIndex, fieldName, fabrics, Parameters);
    setTimeout(() => {
      const fabricList = [];

      let parameters = JSON.parse(
        Parameters === undefined ||
          Parameters === null ||
          Parameters === "undefined" ||
          Parameters === "null" ||
          Parameters === ""
          ? "{}"
          : Parameters
      );
      // console.log(Parameters);

      Object.keys(fabrics).forEach((key, index) => {
        let DesignEnName = fabrics[key][0]["DesignEnName"];
        let DesignCode = fabrics[key][0]["DesignCode"]?.toString();
        let designTypeSelected =
          parameters["Designs"] &&
          parameters["Designs"][DesignCode] &&
          parameters["Designs"][DesignCode]["type"]
            ? [
                {
                  value: parameters["Designs"][DesignCode]["type"].toString(),
                  label: DesignType.find(
                    (opt) => opt.value === parameters["Designs"][DesignCode]["type"].toString()
                  )["label"],
                },
              ]
            : [];

        let designOrderSelected =
          parameters["Designs"] &&
          parameters["Designs"][DesignCode] &&
          parameters["Designs"][DesignCode]["order"]
            ? parameters["Designs"][DesignCode]["order"]
            : -1;
        let designOnlyOneSelected =
          parameters["Designs"] &&
          parameters["Designs"][DesignCode] &&
          parameters["Designs"][DesignCode]["onlyOne"]
            ? parameters["Designs"][DesignCode]["onlyOne"]
            : false;

        const fabric = [];
        for (let j = 0; j < fabrics[key].length; j++) {
          let FabricId = fabrics[key][j].FabricId;
          let fabricOrderSelected =
            parameters["Fabrics"] &&
            parameters["Fabrics"][FabricId] &&
            parameters["Fabrics"][FabricId]["order"]
              ? parameters["Fabrics"][FabricId]["order"]
              : -1;

          let PhotoPath = "";
          fabrics[key][j]["FabricPhotos"].forEach((obj) => {
            if (obj["PhotoTypeId"] === 4702) PhotoPath = obj["PhotoUrl"];
          });
          // console.log(PhotoPath);

          let ColorEnName = fabrics[key][j]["ColorEnName"];

          if (fabricOrderSelected !== -1 && !fabric[fabricOrderSelected]) {
            fabric[fabricOrderSelected] = (
              <div className={`radio_group`} key={"fabric" + key + j}>
                <label>
                  <div className="frame_img">
                    <img
                      className={`img-fluid`}
                      src={imgUrl(PhotoPath)}
                      alt=""
                    />
                  </div>
                </label>
                <div className={`fabric_name_container`}>
                  <h1>{ColorEnName}</h1>
                  <span>
                    <input
                      className="page_item_fabric_order_input"
                      type="number"
                      defaultValue={fabricOrderSelected}
                      onChange={(e) => {
                        if (e.target.value !== "" || e.target.value !== "-1") {
                          let temp = JSON.parse(JSON.stringify(fabricOrders));
                          temp["refIndex"] = refIndex;
                          temp["id"] = FabricId;
                          temp["order"] = Math.abs(parseInt(e.target.value));
                          temp["fabrics"] = fabrics;
                          // console.log(temp["order"],temp["refIndex"]);
                          setFabricOrders(temp);
                          e.target.value = Math.abs(parseInt(e.target.value)).toString();
                        }
                      }}
                    />
                  </span>
                </div>
              </div>
            );
          } else {
            let index = fabric.findIndex(Object.is.bind(null, undefined));
            let pushIndex = index === -1 ? fabric.length : index;
            fabric[pushIndex] = (
              <div className={`radio_group`} key={"fabric" + key + j}>
                <label>
                  <div className="frame_img">
                    <img
                      className={`img-fluid`}
                      src={imgUrl(PhotoPath)}
                      alt=""
                    />
                  </div>
                </label>
                <div className={`fabric_name_container`}>
                  <h1>{ColorEnName}</h1>
                  <span>
                    <input
                      className="page_item_fabric_order_input"
                      type="number"
                      defaultValue={fabricOrderSelected}
                      onChange={(e) => {
                        if (e.target.value !== "" || e.target.value !== "-1") {
                          let temp = JSON.parse(JSON.stringify(fabricOrders));
                          temp["refIndex"] = refIndex;
                          temp["id"] = FabricId;
                          temp["order"] = Math.abs(parseInt(e.target.value));
                          temp["fabrics"] = fabrics;
                          // console.log(temp["order"],temp["refIndex"]);
                          setFabricOrders(temp);
                          e.target.value = Math.abs(parseInt(e.target.value)).toString();
                        }
                      }}
                    />
                  </span>
                </div>
              </div>
            );
          }
        }

        // console.log(fabric);
        if (designOrderSelected !== -1 && !fabricList[designOrderSelected]) {
          fabricList[designOrderSelected] = (
            <div className={`material_detail`} key={"fabric" + key}>
              <div className={`material_traits`}>
                <span>
                  {"DESIGN NAME"}: {DesignEnName}
                </span>
                <span>
                  <div className="select_container">
                    <Select
                      className="select"
                      placeholder={"Please Select"}
                      // portal={document.body}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      values={designTypeSelected}
                      onDropdownOpen={() => {
                        let temp1 = window.scrollY;
                        window.scrollTo(window.scrollX, window.scrollY + 1);
                        setTimeout(() => {
                          let temp2 = window.scrollY;
                          if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                        }, 100);
                      }}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControl props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        if (selected.length) {
                          let temp = JSON.parse(JSON.stringify(fabricDesigns));
                          temp["refIndex"] = refIndex;
                          temp["id"] = DesignCode;
                          temp["type"] = selected[0]["value"];
                          temp["fabrics"] = fabrics;
                          setFabricDesigns(temp);
                        }
                      }}
                      options={DesignType}
                    />
                  </div>
                </span>
                <span>
                  <input
                    className="page_item_fabric_order_input"
                    type="number"
                    defaultValue={designOrderSelected}
                    onChange={(e) => {
                      if (e.target.value !== "" || e.target.value !== "-1") {
                        let temp = JSON.parse(JSON.stringify(fabricDesigns));
                        temp["refIndex"] = refIndex;
                        temp["id"] = DesignCode;
                        temp["order"] = Math.abs(parseInt(e.target.value));
                        temp["fabrics"] = fabrics;
                        setFabricDesigns(temp);
                        e.target.value = Math.abs(parseInt(e.target.value)).toString();
                      }
                    }}
                  />
                </span>
                <span>
                  <div className="checkbox_style">
                    <input
                      type="checkbox"
                      defaultChecked={designOnlyOneSelected}
                      onChange={(e) => {
                        if (e.target.checked) {
                          let temp = JSON.parse(JSON.stringify(fabricDesigns));
                          temp["refIndex"] = refIndex;
                          temp["id"] = DesignCode;
                          temp["onlyOne"] = true;
                          temp["fabrics"] = fabrics;
                          setFabricDesigns(temp);
                        } else {
                          let temp = JSON.parse(JSON.stringify(fabricDesigns));
                          temp["refIndex"] = refIndex;
                          temp["id"] = DesignCode;
                          temp["onlyOne"] = false;
                          temp["fabrics"] = fabrics;
                          setFabricDesigns(temp);
                        }
                      }}
                      id={DesignEnName + key}
                    />
                    <label htmlFor={DesignEnName + key} className="checkbox_label">
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    <span className="checkbox_text">Only 1 Design</span>
                  </div>
                </span>
              </div>
              {fabric}
            </div>
          );
        } else {
          let index = fabricList.findIndex(Object.is.bind(null, undefined));
          let pushIndex = index === -1 ? fabricList.length : index;
          fabricList[pushIndex] = (
            <div className={`material_detail`} key={"fabric" + key}>
              <div className={`material_traits`}>
                <span>
                  {"DESIGN NAME"}: {DesignEnName}
                </span>
                <span>
                  <div className="select_container">
                    <Select
                      className="select"
                      placeholder={"Please Select"}
                      // portal={document.body}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      values={designTypeSelected}
                      onDropdownOpen={() => {
                        let temp1 = window.scrollY;
                        window.scrollTo(window.scrollX, window.scrollY + 1);
                        setTimeout(() => {
                          let temp2 = window.scrollY;
                          if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                        }, 100);
                      }}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControl props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        if (selected.length) {
                          let temp = JSON.parse(JSON.stringify(fabricDesigns));
                          temp["refIndex"] = refIndex;
                          temp["id"] = DesignCode;
                          temp["type"] = selected[0]["value"];
                          temp["fabrics"] = fabrics;
                          setFabricDesigns(temp);
                        }
                      }}
                      options={DesignType}
                    />
                  </div>
                </span>
                <span>
                  <input
                    className="page_item_fabric_order_input"
                    type="number"
                    defaultValue={designOrderSelected}
                    onChange={(e) => {
                      if (e.target.value !== "" || e.target.value !== "-1") {
                        let temp = JSON.parse(JSON.stringify(fabricDesigns));
                        temp["refIndex"] = refIndex;
                        temp["id"] = DesignCode;
                        temp["order"] = Math.abs(parseInt(e.target.value));
                        temp["fabrics"] = fabrics;
                        setFabricDesigns(temp);
                        e.target.value = Math.abs(parseInt(e.target.value)).toString();
                      }
                    }}
                  />
                </span>
                <span>
                  <div className="checkbox_style">
                    <input
                      type="checkbox"
                      defaultChecked={designOnlyOneSelected}
                      onChange={(e) => {
                        if (e.target.checked) {
                          let temp = JSON.parse(JSON.stringify(fabricDesigns));
                          temp["refIndex"] = refIndex;
                          temp["id"] = DesignCode;
                          temp["onlyOne"] = true;
                          temp["fabrics"] = fabrics;
                          setFabricDesigns(temp);
                        } else {
                          let temp = JSON.parse(JSON.stringify(fabricDesigns));
                          temp["refIndex"] = refIndex;
                          temp["id"] = DesignCode;
                          temp["onlyOne"] = false;
                          temp["fabrics"] = fabrics;
                          setFabricDesigns(temp);
                        }
                      }}
                      id={DesignEnName + key}
                    />
                    <label htmlFor={DesignEnName + key} className="checkbox_label">
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    <span className="checkbox_text">Only 1 Design</span>
                  </div>
                </span>
              </div>
              {fabric}
            </div>
          );
        }
      });
      let fabricsButtonList = [];

      fabricsButtonList[0] = (
        <button
          className="btn btn-primary mt-4 mb-2"
          key={"button1"}
          onClick={(e) => {
            let temp = JSON.parse(JSON.stringify(fabricChanged));
            temp["refIndex"] = refIndex;
            temp["fabrics"] = fabrics;
            setFabricChanged(temp);
          }}
        >
          Apply
        </button>
      );
      fabricsButtonList[1] = (
        <button
          className="btn btn-success mt-4 mb-2"
          key={"button2"}
          onClick={(e) => {
            let temp = JSON.parse(JSON.stringify(fabricChanged));
            temp["refIndex"] = refIndex;
            temp["save"] = true;
            setFabricChanged(temp);
            setShowFabrics(false);
            sortFabric.current.removeAttribute("disabled");
          }}
        >
          Save
        </button>
      );
      fabricsButtonList[2] = (
        <button
          className="btn btn-warning mt-4 mb-2"
          key={"button3"}
          onClick={(e) => {
            let temp = JSON.parse(JSON.stringify(fabricChanged));
            temp["refIndex"] = refIndex;
            temp["clear"] = true;
            setFabricChanged(temp);
            setShowFabrics(false);
            sortFabric.current.removeAttribute("disabled");
          }}
        >
          Clear
        </button>
      );
      setFabricsList(fabricList);
      setFabricsButtonList(fabricsButtonList);
      setShowFabrics(true);
    }, 1000);
  }

  function getFabrics(refIndex, modelID) {
    let tempPageItems = JSON.parse(JSON.stringify(pageItems));
    axios
      .get(baseURLFabrics, {
        params: {
          modelId: modelID,
        },
      })
      .then((response) => {
        let tempArr = [];
        response.data.forEach((obj) => {
          if (obj["DesignEnName"] && obj["DesignCode"]) {
            tempArr.push({ value: obj["DesignCode"].toString(), label: obj["DesignEnName"] });
          }
        });
        tempArr = [...new Set(tempArr.map((obj) => JSON.stringify(obj)))].map((obj) =>
          JSON.parse(obj)
        );
        // console.log(response.data,tempArr);
        tempPageItems[refIndex]["ModelDesigns"] = tempArr;
        // tempPageItems[refIndex]["QueryString"] = "";

        let tempFabrics = {};
        response.data.forEach((obj) => {
          if (
            tempFabrics[obj["DesignEnName"]] === "" ||
            tempFabrics[obj["DesignEnName"]] === undefined ||
            tempFabrics[obj["DesignEnName"]] === null ||
            tempFabrics[obj["DesignEnName"]] === []
          )
            tempFabrics[obj["DesignEnName"]] = [];
          tempFabrics[obj["DesignEnName"]].push(obj);
        });
        tempPageItems[refIndex]["Fabrics"] = tempFabrics;

        axios
          .get(baseURLModel, {
            params: {
              id: modelID,
            },
          })
          .then((response) => {
            let model = response.data || {};
            if (Object.keys(model["Accessories"]).length > 0) {
              let tempObj =
                model["Accessories"].find((obj) => obj["SewingAccessoryId"] === 26) || {};
              let promiseArr = [];
              let tempArr = [];
              let tempFabrics = {};
              if (Object.keys(tempObj).length > 0) {
                tempObj["SewingAccessoryDetails"].forEach((obj, index) => {
                  promiseArr[index] = new Promise((resolve, reject) => {
                    if (obj["DetailId"] === "0000011") {
                      obj["DesignENName"] = "Matching Tieback";
                      obj["DesignName"] = "کمرپرده پارچه ای";
                    }
                    obj["SewingModelAccessoryId"] = tempObj["SewingModelAccessoryId"];

                    if (!obj["DesignCode"] || obj["DesignCode"] === "") {
                      obj["DesignCode"] = index.toString();
                    }
                    if (obj["DesignENName"] && obj["DesignCode"]) {
                      tempArr.push({
                        value: obj["DesignCode"].toString(),
                        label: obj["DesignENName"],
                      });
                    }
                    if (
                      tempFabrics[obj["DesignENName"]] === "" ||
                      tempFabrics[obj["DesignENName"]] === undefined ||
                      tempFabrics[obj["DesignENName"]] === null ||
                      tempFabrics[obj["DesignENName"]] === []
                    )
                      tempFabrics[obj["DesignENName"]] = [];
                    tempFabrics[obj["DesignENName"]].push(obj);
                    resolve();
                  });
                });
                Promise.all(promiseArr).then(() => {
                  tempArr = [...new Set(tempArr.map((obj) => JSON.stringify(obj)))].map((obj) =>
                    JSON.parse(obj)
                  );
                  tempPageItems[refIndex]["AccDesigns"] = tempArr;
                  tempPageItems[refIndex]["AccColors"] = tempFabrics;
                  setPageItems(tempPageItems);
                  // console.log(tempArr,tempFabrics,tempPageItems);
                });
              } else {
                tempPageItems[refIndex]["AccDesigns"] = [];
                tempPageItems[refIndex]["AccColors"] = {};
                setPageItems(tempPageItems);
              }
            } else {
              tempPageItems[refIndex]["AccDesigns"] = [];
              tempPageItems[refIndex]["AccColors"] = {};
              setPageItems(tempPageItems);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function deletePageItems(id) {
    axios
      .delete(baseURLDeletePage, {
        params: {
          id: id,
        },
        headers: authHeader(),
      })
      .then((response) => {
        getPageItems();
        setShowToast(true);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              deletePageItems(id);
            } else {
              setIsLoading(false);
            }
          });
        } else {
          setIsLoading(false);
          console.log("failed");
        }
      });
  }

  function updatePageItems(e, refIndex, delField) {
    const tempPageItems = [...pageItems];
    let postpageItemsArray = 0;
    if (refIndex !== undefined) {
      postpageItemsArray = tempPageItems[refIndex];
    } else {
      postpageItemsArray = tempPageItems[e.target.getAttribute("pageitems_id")];
    }
    let tempChildren = postpageItemsArray["ChildPages"] || [];
    tempChildren = tempChildren.map(function(object, index) {
      return { ChildPageId: object["value"] || object["WebsitePageId"], PageItemOrder: index };
    });

    const formData = new FormData();
    // formData.append("ApiKey", window.$apikey);
    formData.append("WebsitePageId", postpageItemsArray["WebsitePageId"]);
    formData.append("PageName", postpageItemsArray["PageName"]);
    formData.append("LinkName", postpageItemsArray["LinkName"]);
    formData.append("PageTypeId", postpageItemsArray["PageTypeId"]);
    formData.append("ColumnCount", postpageItemsArray["ColumnCount"]);
    formData.append("RelatedPage", postpageItemsArray["RelatedPage"]);
    formData.append("Title", postpageItemsArray["Title"]);
    formData.append("EnTitle", postpageItemsArray["EnTitle"]);
    formData.append("HtmlContent", postpageItemsArray["HtmlContent"]);
    formData.append("HtmlEnContent", postpageItemsArray["HtmlEnContent"]);
    formData.append("Description", postpageItemsArray["Description"]);
    formData.append("DescriptionEn", postpageItemsArray["DescriptionEn"]);
    formData.append("Link", postpageItemsArray["Link"]);
    formData.append("QueryString", postpageItemsArray["QueryString"]);
    formData.append("Parameters", postpageItemsArray["Parameters"]);
    formData.append("ChildPages", JSON.stringify(tempChildren || []));
    if (
      postpageItemsArray["ShowWithChild"] === true ||
      postpageItemsArray["ShowWithChild"] === false
    ) {
      formData.append("ShowWithChild", postpageItemsArray["ShowWithChild"]);
    }
    // console.log(postpageItemsArray);

    if (
      postpageItemsArray["Price"] === null ||
      postpageItemsArray["Price"] === undefined ||
      postpageItemsArray["Price"] === ""
    ) {
      formData.append("Price", 0);
    } else {
      formData.append("Price", postpageItemsArray["Price"]);
    }
    if (
      postpageItemsArray["DiscountPrice"] === null ||
      postpageItemsArray["DiscountPrice"] === undefined ||
      postpageItemsArray["DiscountPrice"] === ""
    ) {
      formData.append("DiscountPrice", 0);
    } else {
      formData.append("DiscountPrice", postpageItemsArray["DiscountPrice"]);
    }
    if (postpageItemsArray["Price"] || postpageItemsArray["DiscountPrice"]) {
      formData.append(
        "DiscountPercent",
        parseInt(
          ((1 - postpageItemsArray["DiscountPrice"] / postpageItemsArray["Price"]) * 100).toFixed(2)
        )
      );
    } else {
      formData.append("DiscountPercent", 0);
    }
    if (postpageItemsArray["ImageFile"] === null || postpageItemsArray["ImageFile"] === undefined) {
      formData.append("ImageUrl", postpageItemsArray["ImageUrl"]);
      formData.append("ImageFile", null);
    } else {
      formData.append("ImageFile", postpageItemsArray["ImageFile"]);
      formData.append("ImageUrl", null);
    }
    if (
      postpageItemsArray["MainImageFile"] === null ||
      postpageItemsArray["MainImageFile"] === undefined
    ) {
      formData.append("MainImageUrl", postpageItemsArray["MainImageUrl"]);
      formData.append("MainImageFile", null);
    } else {
      formData.append("MainImageFile", postpageItemsArray["MainImageFile"]);
      formData.append("MainImageUrl", null);
    }
    formData.delete(delField);
    // console.log(postpageItemsArray);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        ...authHeader(),
      },
    };
    setIsLoading(true);
    console.log(`formData`, formData);
    axios
      .post(baseURLEditPage, formData, config)
      .then(() => {
        setShowToast(true);
        getPageItems();
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              updatePageItems(e, refIndex, delField);
            } else {
              setIsLoading(false);
            }
          });
        } else {
          setIsLoading(false);
          console.log("failed");
        }
      });
  }

  function addPageItems() {
    let postpageItemsArray = JSON.parse(JSON.stringify(newPageItem));
    const formData = new FormData();
    // formData.append("ApiKey", window.$apikey);
    // formData.append("WebsitePageId", postpageItemsArray['WebsitePageId']);
    formData.append("PageName", postpageItemsArray["PageName"]);
    formData.append("PageTypeId", postpageItemsArray["PageTypeId"]);
    formData.append("ColumnCount", postpageItemsArray["ColumnCount"]);
    formData.append("Title", postpageItemsArray["Title"]);
    formData.append("EnTitle", postpageItemsArray["EnTitle"]);
    formData.append("HtmlContent", postpageItemsArray["HtmlContent"]);
    formData.append("HtmlEnContent", postpageItemsArray["HtmlEnContent"]);
    formData.append("Description", postpageItemsArray["Description"]);
    formData.append("DescriptionEn", postpageItemsArray["DescriptionEn"]);
    formData.append("Link", "");
    formData.append("QueryString", "");

    if (
      postpageItemsArray["Price"] === null ||
      postpageItemsArray["Price"] === undefined ||
      postpageItemsArray["Price"] === ""
    ) {
      formData.append("Price", 0);
    } else {
      formData.append("Price", postpageItemsArray["Price"]);
    }
    if (
      postpageItemsArray["DiscountPrice"] === null ||
      postpageItemsArray["DiscountPrice"] === undefined ||
      postpageItemsArray["DiscountPrice"] === ""
    ) {
      formData.append("DiscountPrice", 0);
    } else {
      formData.append("DiscountPrice", postpageItemsArray["DiscountPrice"]);
    }
    if (postpageItemsArray["Price"] || postpageItemsArray["DiscountPrice"]) {
      formData.append(
        "DiscountPercent",
        parseInt(
          ((1 - postpageItemsArray["DiscountPrice"] / postpageItemsArray["Price"]) * 100).toFixed(2)
        )
      );
    } else {
      formData.append("DiscountPercent", 0);
    }
    if (postpageItemsArray["ImageFile"] === null || postpageItemsArray["ImageFile"] === undefined) {
      formData.append("ImageUrl", postpageItemsArray["ImageUrl"]);
      formData.append("ImageFile", null);
    } else {
      formData.append("ImageFile", postpageItemsArray["ImageFile"]);
      formData.append("ImageUrl", null);
    }
    if (
      postpageItemsArray["MainImageFile"] === null ||
      postpageItemsArray["MainImageFile"] === undefined
    ) {
      formData.append("MainImageUrl", postpageItemsArray["MainImageUrl"]);
      formData.append("MainImageFile", null);
    } else {
      formData.append("MainImageFile", postpageItemsArray["MainImageFile"]);
      formData.append("MainImageUrl", null);
    }
    console.log(newPageItem);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        ...authHeader(),
      },
    };
    setIsLoading(true);
    axios
      .post(baseURLAddPage, formData, config)
      .then(() => {
        setShowToast(true);
        handleClose();
        getPageItems();
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              addPageItems();
            } else {
              setIsLoading(false);
            }
          });
        } else {
          setIsLoading(false);
          console.log("failed");
        }
      });
  }

  function updatePicture(e, isAdd) {
    if (isAdd) {
      let file = e.target.files[0];
      let tempPageItem = JSON.parse(JSON.stringify(newPageItem));
      tempPageItem[e.target.getAttribute("pageitems_text_id")] = file;
      setNewPageItem(tempPageItem);
    } else {
      let file = e.target.files[0];
      const tempPageItems = [...pageItems];
      tempPageItems[e.target.getAttribute("pageitems_id")][
        e.target.getAttribute("pageitems_text_id")
      ] = file;
      setPageItems(tempPageItems);
    }
  }

  function textEditorChanged(tempText, i, pageitems_text_id, isAdd) {
    if (isAdd) {
      let tempPageItem = JSON.parse(JSON.stringify(newPageItem));
      tempPageItem[pageitems_text_id] = convertToPersian(tempText);
      setNewPageItem(tempPageItem);
    } else {
      const tempPageItems = [...pageItems];
      tempPageItems[i][pageitems_text_id] = convertToPersian(tempText);
      setPageItems(tempPageItems);
      // console.log(pageItems)
    }
  }

  function textChanged(e, isAdd) {
    if (isAdd) {
      let tempPageItem = JSON.parse(JSON.stringify(newPageItem));
      tempPageItem[e.target.getAttribute("pageitems_text_id")] = e.target.value;
      setNewPageItem(tempPageItem);
    } else {
      const tempPageItems = [...pageItems];
      tempPageItems[e.target.getAttribute("pageitems_id")][
        e.target.getAttribute("pageitems_text_id")
      ] = e.target.value;
      setPageItems(tempPageItems);
      // console.log(pageItems)
    }
  }

  function clearField(e, refIndex, fieldName) {
    const tempPageItems = [...pageItems];
    tempPageItems[refIndex][fieldName] = "";
    setPageItemsList([]);
    setPageCount(Math.ceil(0 / itemsPerPage));
    updatePageItems(e, refIndex);
    // setPageItems(tempPageItems);
  }

  function setSelection(refIndex, fieldName, value, isAdd) {
    if (isAdd) {
      let tempPageItem = JSON.parse(JSON.stringify(newPageItem));
      tempPageItem[fieldName] = value;
      setNewPageItem(tempPageItem);
    } else {
      const tempPageItems = [...pageItems];
      let UrlLink = pageItems[refIndex].Link ? pageItems[refIndex].Link : "";
      let UrlLinkArr = UrlLink.split("/");
      let Link = UrlLinkArr[0] ? UrlLinkArr[0] : "";
      let PageType = UrlLinkArr[1] ? UrlLinkArr[1] : "";

      if (fieldName === "Link") {
        if (PageType !== "") {
          tempPageItems[refIndex]["Link"] = value + "/" + PageType;
        } else {
          tempPageItems[refIndex]["Link"] = value;
        }
        tempPageItems[refIndex]["Link"] = tempPageItems[refIndex]["Link"].replace(/^\/|\/$/g, "");
      } else if (fieldName === "PageType") {
        if (Link !== "") {
          tempPageItems[refIndex]["Link"] = Link + "/" + value;
        } else {
          tempPageItems[refIndex]["Link"] = "";
        }
        tempPageItems[refIndex]["Link"] = tempPageItems[refIndex]["Link"].replace(/^\/|\/$/g, "");
      } else {
        tempPageItems[refIndex][fieldName] = value;
      }
      setPageItems(tempPageItems);
      // console.log(tempPageItems[refIndex]["Link"]);
    }
  }

  function setMultiSelection(refIndex, fieldName, searchQuery, value, isAdd) {
    console.log(refIndex, fieldName, searchQuery, value, isAdd);
    if (isAdd) {
    } else {
      const tempPageItems = [...pageItems];
      let tempParams = tempPageItems[refIndex][fieldName] ? tempPageItems[refIndex][fieldName] : "";

      let allParamQueryArr = tempParams.split(searchQuery);
      let paramQueryArr = allParamQueryArr[1] ? allParamQueryArr[1].split("&") : [];

      let paramQuerySelected = [...new Set(value)].filter((n) => n).join(",");
      if (allParamQueryArr.length > 1) {
        paramQueryArr[0] = paramQuerySelected;
        allParamQueryArr[1] = paramQueryArr.join("&");
        if (paramQuerySelected === "") {
          tempPageItems[refIndex][fieldName] = allParamQueryArr
            .join("")
            .replace(/&$/, "")
            .replace(/&+/g, "&")
            .replace(/^(&)/, "");
        } else {
          tempPageItems[refIndex][fieldName] = allParamQueryArr.join(searchQuery);
        }
      } else {
        if (tempParams !== "") {
          if (paramQuerySelected === "") {
            tempPageItems[refIndex][fieldName] = tempParams
              .replace(/&$/, "")
              .replace(/&+/g, "&")
              .replace(/^(&)/, "");
          } else {
            tempPageItems[refIndex][fieldName] =
              tempParams + "&" + searchQuery + paramQuerySelected;
          }
        } else {
          if (paramQuerySelected === "") {
            tempPageItems[refIndex][fieldName] = "";
          } else {
            tempPageItems[refIndex][fieldName] = searchQuery + paramQuerySelected;
          }
        }
      }

      setPageItems(tempPageItems);
      // console.log(tempPageItems,tempPageItems[refIndex][fieldName])
    }
  }

  function numberChanged(e, isAdd) {
    if (isAdd) {
      let tempPageItem = JSON.parse(JSON.stringify(newPageItem));
      tempPageItem[e.target.getAttribute("pageitems_text_id")] = parseInt(e.target.value);
      if (
        e.target.getAttribute("pageitems_text_id") === "Price" ||
        e.target.getAttribute("pageitems_text_id") === "DiscountPrice"
      ) {
        if (tempPageItem["Price"] && tempPageItem["DiscountPrice"]) {
          tempPageItem["DiscountPercent"] = (
            (1 - tempPageItem["DiscountPrice"] / tempPageItem["Price"]) *
            100
          ).toFixed(2);
        }
      }
      setNewPageItem(tempPageItem);
    } else {
      const tempPageItems = [...pageItems];
      tempPageItems[e.target.getAttribute("pageitems_id")][
        e.target.getAttribute("pageitems_text_id")
      ] = parseInt(e.target.value);
      if (
        e.target.getAttribute("pageitems_text_id") === "Price" ||
        e.target.getAttribute("pageitems_text_id") === "DiscountPrice"
      ) {
        if (
          tempPageItems[e.target.getAttribute("pageitems_id")]["Price"] &&
          tempPageItems[e.target.getAttribute("pageitems_id")]["DiscountPrice"]
        ) {
          tempPageItems[e.target.getAttribute("pageitems_id")]["DiscountPercent"] = (
            (1 -
              tempPageItems[e.target.getAttribute("pageitems_id")]["DiscountPrice"] /
                tempPageItems[e.target.getAttribute("pageitems_id")]["Price"]) *
            100
          ).toFixed(2);
        }
      }
      setPageItems(tempPageItems);
    }
  }

  function handleClose() {
    setShow(false);
    setNewPageItem({
      Title: "",
      EnTitle: "",
      Price: 0,
      DiscountPrice: 0,
      DiscountPercent: 0,
      Description: null,
      DescriptionEn: null,
      ImageFile: null,
      ImageUrl: null,
      OverImageFile: null,
      OverImageUrl: null,
      MainImageFile: null,
      MainImageUrl: null,
      Link: "",
      QueryString: "",
      HtmlContent: "",
      HtmlEnContent: "",
    });
  }

  useEffect(() => {
    if (fabricDesigns2["id"]) {
      let tempPageItems = JSON.parse(JSON.stringify(pageItems));

      let params = JSON.parse(JSON.stringify(parameters));

      if (params["Designs"]) {
        if (params["Designs"][fabricDesigns2["id"]]) {
          params["Designs"][fabricDesigns2["id"]]["type"] =
            fabricDesigns2["type"] === null
              ? params["Designs"][fabricDesigns2["id"]]["type"]
              : fabricDesigns2["type"];
          params["Designs"][fabricDesigns2["id"]]["order"] =
            fabricDesigns2["order"] === -1
              ? params["Designs"][fabricDesigns2["id"]]["order"]
              : fabricDesigns2["order"];
          params["Designs"][fabricDesigns2["id"]]["onlyOne"] =
            fabricDesigns2["onlyOne"] === null
              ? params["Designs"][fabricDesigns2["id"]]["onlyOne"]
              : fabricDesigns2["onlyOne"];
        } else {
          params["Designs"][fabricDesigns2["id"]] = {};
          params["Designs"][fabricDesigns2["id"]]["type"] =
            fabricDesigns2["type"] === null ? "none" : fabricDesigns2["type"];
          params["Designs"][fabricDesigns2["id"]]["order"] =
            fabricDesigns2["order"] === -1 ? -1 : fabricDesigns2["order"];
          params["Designs"][fabricDesigns2["id"]]["onlyOne"] =
            fabricDesigns2["onlyOne"] === null ? null : fabricDesigns2["onlyOne"];
        }
      } else {
        params["Designs"] = {};
        params["Designs"][fabricDesigns2["id"]] = {};
        params["Designs"][fabricDesigns2["id"]]["type"] =
          fabricDesigns2["type"] === null ? "none" : fabricDesigns2["type"];
        params["Designs"][fabricDesigns2["id"]]["order"] =
          fabricDesigns2["order"] === -1 ? -1 : fabricDesigns2["order"];
        params["Designs"][fabricDesigns2["id"]]["onlyOne"] =
          fabricDesigns2["onlyOne"] === null ? null : fabricDesigns2["onlyOne"];
      }

      tempPageItems[fabricDesigns2["refIndex"]]["Fabrics"] = fabricDesigns2["fabrics"];
      tempPageItems[fabricDesigns2["refIndex"]]["Parameters"] = JSON.stringify(params);
      setParameters(params);
      setPageItems(tempPageItems);

      // console.log(fabricDesigns2,params["Designs"][fabricDesigns2["id"]])

      setFabricDesigns2({
        refIndex: null,
        id: null,
        type: null,
        order: -1,
        onlyOne: null,
        fabrics: [],
      });
    }
  }, [fabricDesigns2]);

  useEffect(() => {
    if (fabricDesigns["id"]) {
      let tempPageItems = JSON.parse(JSON.stringify(pageItems));

      let Parameters = tempPageItems[fabricDesigns["refIndex"]].Parameters
        ? tempPageItems[fabricDesigns["refIndex"]].Parameters
        : "{}";
      let params = JSON.parse(Parameters);

      if (params["Designs"]) {
        if (params["Designs"][fabricDesigns["id"]]) {
          params["Designs"][fabricDesigns["id"]]["type"] =
            fabricDesigns["type"] === null
              ? params["Designs"][fabricDesigns["id"]]["type"]
              : fabricDesigns["type"];
          params["Designs"][fabricDesigns["id"]]["order"] =
            fabricDesigns["order"] === -1
              ? params["Designs"][fabricDesigns["id"]]["order"]
              : fabricDesigns["order"];
          params["Designs"][fabricDesigns["id"]]["onlyOne"] =
            fabricDesigns["onlyOne"] === null
              ? params["Designs"][fabricDesigns["id"]]["onlyOne"]
              : fabricDesigns["onlyOne"];
        } else {
          params["Designs"][fabricDesigns["id"]] = {};
          params["Designs"][fabricDesigns["id"]]["type"] =
            fabricDesigns["type"] === null ? "none" : fabricDesigns["type"];
          params["Designs"][fabricDesigns["id"]]["order"] =
            fabricDesigns["order"] === -1 ? -1 : fabricDesigns["order"];
          params["Designs"][fabricDesigns["id"]]["onlyOne"] =
            fabricDesigns["onlyOne"] === null ? null : fabricDesigns["onlyOne"];
        }
      } else {
        params["Designs"] = {};
        params["Designs"][fabricDesigns["id"]] = {};
        params["Designs"][fabricDesigns["id"]]["type"] =
          fabricDesigns["type"] === null ? "none" : fabricDesigns["type"];
        params["Designs"][fabricDesigns["id"]]["order"] =
          fabricDesigns["order"] === -1 ? -1 : fabricDesigns["order"];
        params["Designs"][fabricDesigns["id"]]["onlyOne"] =
          fabricDesigns["onlyOne"] === null ? null : fabricDesigns["onlyOne"];
      }

      tempPageItems[fabricDesigns["refIndex"]]["Fabrics"] = fabricDesigns["fabrics"];
      tempPageItems[fabricDesigns["refIndex"]]["Parameters"] = JSON.stringify(params);
      setPageItems(tempPageItems);
    }
  }, [fabricDesigns]);

  useEffect(() => {
    if (fabricOrders["id"]) {
      let tempPageItems = JSON.parse(JSON.stringify(pageItems));

      let Parameters = tempPageItems[fabricOrders["refIndex"]].Parameters
        ? tempPageItems[fabricOrders["refIndex"]].Parameters
        : "{}";
      let params = JSON.parse(Parameters);

      if (params["Fabrics"]) {
        if (params["Fabrics"][fabricOrders["id"]]) {
          params["Fabrics"][fabricOrders["id"]]["order"] =
            fabricOrders["order"] === -1
              ? params["Designs"][fabricOrders["id"]]["order"]
              : fabricOrders["order"];
        } else {
          params["Fabrics"][fabricOrders["id"]] = {};
          params["Fabrics"][fabricOrders["id"]]["order"] =
            fabricOrders["order"] === -1 ? -1 : fabricOrders["order"];
        }
      } else {
        params["Fabrics"] = {};
        params["Fabrics"][fabricOrders["id"]] = {};
        params["Fabrics"][fabricOrders["id"]]["order"] =
          fabricOrders["order"] === -1 ? -1 : fabricOrders["order"];
      }

      tempPageItems[fabricOrders["refIndex"]]["Fabrics"] = fabricOrders["fabrics"];
      tempPageItems[fabricOrders["refIndex"]]["Parameters"] = JSON.stringify(params);
      setPageItems(tempPageItems);
    }
  }, [fabricOrders]);

  useEffect(() => {
    if (fabricChanged["refIndex"] !== -1) {
      if (fabricChanged["save"]) {
        updatePageItems(undefined, fabricChanged["refIndex"]);
        setFabricChanged({
          refIndex: -1,
          fabrics: [],
          save: false,
          clear: false,
        });
        // console.log(pageItems);
      } else if (fabricChanged["clear"]) {
        let tempPageItems = JSON.parse(JSON.stringify(pageItems));
        tempPageItems[fabricChanged["refIndex"]]["Parameters"] = "";
        tempPageItems[fabricChanged["refIndex"]]["Fabrics"] = undefined;
        setPageItems(tempPageItems);
        updatePageItems(undefined, fabricChanged["refIndex"], "Parameters");
        setFabricChanged({
          refIndex: -1,
          fabrics: [],
          save: false,
          clear: false,
        });
      } else {
        let tempPageItems = JSON.parse(JSON.stringify(pageItems));
        renderFabrics(
          fabricChanged["refIndex"],
          "Parameters",
          fabricChanged["fabrics"],
          tempPageItems[fabricChanged["refIndex"]]["Parameters"]
        );
        setFabricChanged({
          refIndex: -1,
          fabrics: [],
          save: false,
          clear: false,
        });
      }
    }
  }, [fabricChanged]);

  useEffect(() => {
    if (pageItemsList.length) {
      let endOffset = itemOffset + itemsPerPage;
      setCurrentPageItemsList(pageItemsList.slice(itemOffset, endOffset));
    } else {
      setCurrentPageItemsList([]);
    }
  }, [pageItemsList, itemOffset]);

  useEffect(() => {
    renderPageItems();
    setItemOffset(0);
  }, [searchQuery]);

  useEffect(() => {
    getSelections();
  }, []);

  useEffect(() => {
    if (pageItems.length && childrenPageItems.length) {
      // console.log(pageItems);
      renderPageItems();
    }
  }, [pageItems, childrenPageItems]);

  return (
    <div className="pageItems_page_container">
      <LoadingOverlay active={isLoading} spinner className={isLoading ? "loading_overlay" : ""}>
        <h1 className="pageItems_title">Page List</h1>
        <div className="pageItems_list_header">
          <div className="pageItems_small_inputs 5">
            <button className="btn btn-success mt-2 mb-2" onClick={(e) => setShow(true)}>
              Add Page
            </button>
          </div>
          <div className="pageItems_pagination">
            <ReactPaginate
              key={pageItemsList.length}
              breakLabel="..."
              nextLabel="next Page >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={6}
              pageCount={pageCount}
              previousLabel="< previous Page"
              renderOnZeroPageCount={null}
            />
          </div>
          <div className="pageItems_small_inputs pageItem_search 6">
            <FormControl
              type="search"
              placeholder="Search ID / Page Name / Title (EN/FA)"
              className="me-2"
              aria-label="Search"
              onChange={(e) => setSearchQuery(e.target.value.toString())}
            />
          </div>
        </div>
        <div className="pageItems">
          <ul className="pageItems_list">{currentPageItemsList}</ul>
        </div>

        <Modal
          dialogClassName="page_item_fabric_modal"
          show={showFabrics}
          onHide={() => {
            setShowFabrics(false);
            sortFabric.current.removeAttribute("disabled");
          }}
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="card_body card-body-fabric">
              <div className="fabrics_list_container">
                {fabricsList}
                {fabricsButtonList}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        <Modal
          className="page_item_fabric_modal_container"
          dialogClassName="page_item_fabric_modal"
          show={showFabrics2}
          onHide={() => {
            setShowFabrics2(false);
            sortFabric.current.removeAttribute("disabled");
          }}
          scrollable={false}
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="card_body card-body-fabric">
              <div
                className={
                  fabricIsLoading ? "is_loading fabrics_list_container 1" : "fabrics_list_container"
                }
              >
                {isDesignDrag === 0 && dragListFabricsList}
                {isDesignDrag === 1 && dragListDesignsList}
                {isDesignDrag === 2 && dragListAccessoryList}
                {isDesignDrag === 3 && dragListAccessoryColorsList}
              </div>
              <div className="pageItem_fabrics_btn_container">
                <div className="help_options_container">
                  <ul className="help_options help_options_lengthType">
                    <li
                      className={`help_option_lengthType_item ${
                        isDesignDrag === 0 ? "help_option_lengthType_item_on" : ""
                      }`}
                      onClick={() => setIsDesignDrag(0)}
                    >
                      Fabrics
                    </li>
                    <li
                      className={`help_option_lengthType_item ${
                        isDesignDrag === 1 ? "help_option_lengthType_item_on" : ""
                      }`}
                      onClick={() => setIsDesignDrag(1)}
                    >
                      Designs
                    </li>
                    <li
                      className={`help_option_lengthType_item ${
                        isDesignDrag === 2 ? "help_option_lengthType_item_on" : ""
                      }`}
                      onClick={() => setIsDesignDrag(2)}
                    >
                      Accessory Colors
                    </li>
                    <li
                      className={`help_option_lengthType_item ${
                        isDesignDrag === 3 ? "help_option_lengthType_item_on" : ""
                      }`}
                      onClick={() => setIsDesignDrag(3)}
                    >
                      Accessories
                    </li>
                  </ul>
                </div>
                <div>
                  <button
                    className="btn btn-success mt-4 mb-2"
                    onClick={() => {
                      let tempPageItems = JSON.parse(JSON.stringify(pageItems));

                      tempPageItems[refIndex]["Parameters"] = JSON.stringify(parameters);
                      setPageItems(tempPageItems);

                      let temp = JSON.parse(JSON.stringify(fabricChanged));
                      temp["refIndex"] = refIndex;
                      temp["save"] = true;
                      setFabricChanged(temp);
                      setShowFabrics2(false);
                      sortFabric.current.removeAttribute("disabled");
                    }}
                  >
                    SAVE
                  </button>
                  <button
                    className="btn btn-warning mt-4 mb-2"
                    onClick={() => {
                      setShowFabrics2(false);
                      sortFabric.current.removeAttribute("disabled");
                    }}
                  >
                    DISCARD
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        <Modal dialogClassName="newPageItemModal" show={show} onHide={() => handleClose()}>
          {/*<Modal.Header closeButton>*/}
          {/*</Modal.Header>*/}
          <Modal.Body>
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => handleClose()}
              />
            </div>
            <ul className="pageItems_list">
              <li>
                <div className="pageItems_small_inputs 7">
                  <label className="input">
                    <input
                      type="text"
                      pageitems_text_id="PageName"
                      defaultValue={newPageItem.PageName}
                      onChange={(e) => textChanged(e, true)}
                      placeholder="Type Something..."
                    />
                    <span className="input__label">Page Name</span>
                  </label>
                  <div className="select_container">
                    <span className="input__label">Page Type</span>
                    <Select
                      className="select"
                      placeholder={"Please Select"}
                      // portal={document.body}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      values={[]}
                      onDropdownOpen={() => {
                        let temp1 = window.scrollY;
                        window.scrollTo(window.scrollX, window.scrollY + 1);
                        setTimeout(() => {
                          let temp2 = window.scrollY;
                          if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                        }, 100);
                      }}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControl props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        if (selected.length) {
                          setSelection(undefined, "PageTypeId", selected[0].value, true);
                        }
                      }}
                      options={PageTypeOptions}
                    />
                  </div>
                  <label className="input">
                    <input
                      type="text"
                      pageitems_text_id="Title"
                      defaultValue={newPageItem.Title}
                      onChange={(e) => textChanged(e, true)}
                      placeholder="Type Something..."
                    />
                    <span className="input__label">PageItems FA Name</span>
                  </label>
                  <label className="input">
                    <input
                      type="text"
                      pageitems_text_id="EnTitle"
                      defaultValue={newPageItem.EnTitle}
                      onChange={(e) => textChanged(e, true)}
                      placeholder="Type Something..."
                    />
                    <span className="input__label">PageItems EN Name</span>
                  </label>
                </div>

                <div className="pageItems_small_inputs 8">
                  <button className="btn btn-success mt-4 mb-2" onClick={(e) => addPageItems()}>
                    ADD
                  </button>
                </div>
              </li>
            </ul>
          </Modal.Body>
        </Modal>

        <ToastContainer className="p-3 position_fixed" position="top-start">
          <Toast
            onClose={() => setShowToast(false)}
            bg="success"
            show={showToast}
            delay={3000}
            autohide
          >
            <Toast.Header>
              <img src={"holder.js/20x20?text=%20"} className="rounded me-2" alt="" />
              <strong className="me-auto">Success</strong>
              {/*<small>couple of seconds ago</small>*/}
            </Toast.Header>
            <Toast.Body>Saved Successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </LoadingOverlay>
    </div>
  );
}

export default PageItems;
